// Connections V1: DES3 design, DES2 reviewed 24-language values.
// Source: org/work/DES2/handoff/access-card-24.json.
import type { NamespaceCatalog } from '@/i18n/ns';

const copy = {
  bg: {
    turnOn: 'Включване на достъпа',
    turnOnConfirm: 'Да се включи ли {name} с показания по-горе достъп?',
    failureUnknown: 'Причината е неизвестна. Тествайте връзката, за да проверите.',
    removeCredentialsConfirm:
      'Да се премахне ли {name}? Poneva спира да чете през тази връзка и изтрива запазените данни за вход. За повторно свързване ще ги въведете отново. Вашите чатове и данни на App остават.',
    fieldRequired: 'Въведете {field}.',
    fieldTooLong: '{field} е твърде дълго.',
    fieldInvalid: 'Проверете {field}.',
    testConnection: 'Тестване на връзката',
    allowWriteDone: 'Записът в {name} е разрешен',
    agentWriteNeeded:
      '{name} е настроен на Четене. За да може този агент да прави промени там, задайте го на Четене и писане във Връзки.',
    agentWriteAsk:
      '{name} е настроен на Четене и само собственикът му или администратор може да промени това. Помолете ги да го зададат на Четене и писане, за да може този агент да прави промени там.',
    openConnections: 'Отваряне на Връзки',
    cardWriteNeeded:
      '{name} е настроен на Четене, затова това не може да се изпълни, докато не бъде настроен на Четене и писане във Връзки.',
    appWritesRow: 'Това приложение прави промени в {name}',
    agentWritesRow: 'Този агент прави промени в {name}',
    appWritesBody:
      'Изпълненията ще правят промени, без да питат. Можете да изключите това в „Редактиране на достъпа“.',
    appWritesAllow: 'Разрешаване',
    cardEditAccess: 'Редактиране на достъпа',
    cardViewAccess: 'Преглед на достъпа',
    kindPipedream: 'Приложение на Pipedream',
    kindCustom: 'Собствена връзка',
    kindDatabase: 'База данни',
    connectedBy: 'свързано от {person}',
    whoOnlyYou: 'Само вие',
    whoEveryone: 'Всички в {company}',
    peopleNoun: 'one:човек|other:души',
    whatRead: 'Четене',
    whatReadWrite: 'Четене и писане',
    statusConnected: 'Свързано',
    statusOff: 'Изключено',
    statusReconnect: 'Нужно е повторно свързване',
    statusUnavailable: 'Не е налично',
    sheetTitle: 'Достъп до {name}',
    sheetTitleConnect: 'Кой може да използва {name}?',
    appliesNext: 'Промените важат от следващата заявка.',
    qWho: 'Кой може да я използва',
    optOnlyMe: 'Само аз',
    optOnlyMeBody: 'Само вие можете да я използвате. Тя никога не се показва на други хора.',
    optEveryone: 'Всички в {company}',
    optEveryoneBody: 'Всеки в {company} може да я използва в своите чатове и приложения.',
    optPeople: 'Конкретни хора',
    addPeople: 'Добавете хора по име или имейл…',
    ownerTag: 'Собственик',
    peopleEmpty: 'Добавете поне един човек или изберете „Само аз“.',
    everyoneAdminOnly: 'Само собственик или администратор може да споделя с всички.',
    qWhat: 'Какво може да прави Poneva',
    optRead: 'Четене',
    optReadBody: 'Poneva може да търси информация. Никога не променя нищо.',
    optReadWrite: 'Четене и писане',
    optReadWriteBody: 'Poneva може и да прави промени. Всяка промяна се записва.',
    reach: 'До какво има достъп',
    actionsNoun: 'one:действие|other:действия',
    reachCount: '{actions} · {read} за четене · {write} за запис',
    reachUnlabelled: 'Действията, които услугата не обозначава, се броят за промени.',
    reachDatabase:
      'Poneva може да чете всичко, което този вход в базата данни вижда. За да споделите по-малко, свържете се с вход, който има достъп само до това, което искате да споделите.',
    turnOff: 'Изключване на достъпа',
    turnOffConfirm:
      'Да се изключи ли {name}? Никой не може да използва връзката, докато не бъде включена отново. Нищо не се изтрива.',
    remove: 'Премахване на връзката',
    removeConfirm:
      'Да се премахне ли {name}? Това изтрива запазения от Poneva вход. Чатовете и приложенията, които са използвали връзката, спират да работят. Данните, вече показани или запазени в приложенията, остават там, където са.',
    readOnlyNote: 'Само {owner} или администратор може да промени това.',
    saved: 'Достъпът е обновен. Важи от следващата заявка.',
    conflict: 'Някой друг е променил това. Ето текущата настройка.',
    saveFailed: 'Не можа да се запази. Опитайте отново.',
    yourAccess: 'Вашият достъп',
    ownWrite: 'Poneva може да записва в {name} от ваше име. Разрешихте това на {date}.',
    ownWriteStop: 'Спиране на записа от мое име',
    ownWriteStopConfirm:
      'Да спре ли Poneva да записва в {name} от ваше име? Само собственикът или администратор може отново да разреши записа.',
    ownWriteStopYes: 'Спиране на записа',
    ownWriteKeep: 'Запазване',
    ownRead:
      'Poneva може да чете {name} от ваше име. Докато е настроен на Четене, не променя нищо там.',
    audienceWrite: 'Записът е разрешен за всички, които могат да използват {name}.',
    onlyRead: 'Poneva може само да чете {name}.',
    youSuffix: '(вие)',
    forEveryone: '{what}, за всички',
    activityTitle: 'Дейност',
    activityEmpty:
      'Все още няма дейност. Всеки път, когато Poneva използва връзка, това се показва тук.',
  },
  cs: {
    turnOn: 'Zapnout přístup',
    turnOnConfirm: 'Zapnout {name} s výše uvedeným přístupem?',
    failureUnknown: 'Důvod není znám. Ověřte jej testem připojení.',
    removeCredentialsConfirm:
      'Odebrat {name}? Poneva přes toto připojení přestane číst a odstraní uložené přihlašovací údaje. Pro nové připojení je zadáte znovu. Vaše chaty a data App zůstanou.',
    fieldRequired: 'Zadejte {field}.',
    fieldTooLong: '{field} je příliš dlouhé.',
    fieldInvalid: 'Zkontrolujte {field}.',
    testConnection: 'Testovat připojení',
    allowWriteDone: 'Zápis do služby {name} povolen',
    agentWriteNeeded:
      '{name} je nastaven na Čtení. Aby v něm tento agent mohl provádět změny, nastavte ho v Připojeních na Čtení a zápis.',
    agentWriteAsk:
      '{name} je nastaven na Čtení a změnit to může jen jeho vlastník nebo správce. Požádejte je, aby ho nastavili na Čtení a zápis, aby v něm tento agent mohl provádět změny.',
    openConnections: 'Otevřít Připojení',
    cardWriteNeeded:
      '{name} je nastaven na Čtení, takže to nelze provést, dokud nebude v Připojeních nastaven na Čtení a zápis.',
    appWritesRow: 'Tato aplikace provádí změny ve službě {name}',
    agentWritesRow: 'Tento agent provádí změny ve službě {name}',
    appWritesBody:
      'Spuštění budou provádět změny bez ptaní. Vypnout to můžete v části Upravit přístup.',
    appWritesAllow: 'Povolit',
    cardEditAccess: 'Upravit přístup',
    cardViewAccess: 'Zobrazit přístup',
    kindPipedream: 'Aplikace Pipedream',
    kindCustom: 'Vlastní připojení',
    kindDatabase: 'Databáze',
    connectedBy: 'připojeno: {person}',
    whoOnlyYou: 'Jen vy',
    whoEveryone: 'Všichni ve firmě {company}',
    peopleNoun: 'one:člověk|few:lidé|many:lidí|other:lidí',
    whatRead: 'Čtení',
    whatReadWrite: 'Čtení a zápis',
    statusConnected: 'Připojeno',
    statusOff: 'Vypnuto',
    statusReconnect: 'Je potřeba znovu připojit',
    statusUnavailable: 'Není k dispozici',
    sheetTitle: 'Přístup ke službě {name}',
    sheetTitleConnect: 'Kdo může používat službu {name}?',
    appliesNext: 'Změny platí od dalšího požadavku.',
    qWho: 'Kdo ho může používat',
    optOnlyMe: 'Jen já',
    optOnlyMeBody: 'Používat ho můžete jen vy. Nikomu dalšímu se nezobrazí.',
    optEveryone: 'Všichni ve firmě {company}',
    optEveryoneBody: 'Kdokoli ve firmě {company} ho může používat ve svých chatech a aplikacích.',
    optPeople: 'Konkrétní lidé',
    addPeople: 'Přidejte lidi podle jména nebo e-mailu…',
    ownerTag: 'Vlastník',
    peopleEmpty: 'Přidejte aspoň jednoho člověka, nebo zvolte Jen já.',
    everyoneAdminOnly: 'Sdílet se všemi může jen vlastník nebo správce.',
    qWhat: 'Co může Poneva dělat',
    optRead: 'Čtení',
    optReadBody: 'Poneva může vyhledávat informace. Nikdy nic nemění.',
    optReadWrite: 'Čtení a zápis',
    optReadWriteBody: 'Poneva může také provádět změny. Každá změna se zaznamená.',
    reach: 'K čemu má přístup',
    actionsNoun: 'one:akce|few:akce|many:akce|other:akcí',
    reachCount: '{actions} · čtení: {read} · zápis: {write}',
    reachUnlabelled: 'Akce, které služba neoznačí, se počítají jako změny.',
    reachDatabase:
      'Poneva může číst cokoli, co vidí toto přihlášení k databázi. Chcete-li sdílet méně, připojte se přihlášením, které má přístup jen k tomu, co chcete sdílet.',
    turnOff: 'Vypnout přístup',
    turnOffConfirm:
      'Vypnout službu {name}? Dokud ji znovu nezapnete, nikdo ji nebude moct používat. Nic se nesmaže.',
    remove: 'Odebrat připojení',
    removeConfirm:
      'Odebrat službu {name}? Tím se smaže přihlášení, které Poneva uložila. Chaty a aplikace, které ji používaly, přestanou fungovat. Data, která už byla zobrazena nebo uložena v aplikacích, zůstanou tam, kde jsou.',
    readOnlyNote: 'Změnit to může jen {owner} nebo správce.',
    saved: 'Přístup byl aktualizován. Platí od dalšího požadavku.',
    conflict: 'Někdo jiný to změnil. Toto je aktuální nastavení.',
    saveFailed: 'Uložení se nezdařilo. Zkuste to znovu.',
    yourAccess: 'Váš přístup',
    ownWrite: 'Poneva může za vás zapisovat do služby {name}. Povolili jste to {date}.',
    ownWriteStop: 'Zastavit zápis za mě',
    ownWriteStopConfirm:
      'Zastavit zápis Poneva do služby {name} za vás? Zápis znovu zapnout může jen vlastník nebo správce.',
    ownWriteStopYes: 'Zastavit zápis',
    ownWriteKeep: 'Ponechat',
    ownRead:
      'Poneva může za vás číst data ze služby {name}. Dokud je nastavená na Čtení, nic v ní nemění.',
    audienceWrite: 'Zápis je povolen všem, kdo mohou používat službu {name}.',
    onlyRead: 'Poneva může data ze služby {name} jen číst.',
    youSuffix: '(vy)',
    forEveryone: '{what}, pro všechny',
    activityTitle: 'Aktivita',
    activityEmpty:
      'Zatím žádná aktivita. Pokaždé, když Poneva použije připojení, objeví se to tady.',
  },
  da: {
    turnOn: 'Slå adgang til',
    turnOnConfirm: 'Slå {name} til med adgangen vist ovenfor?',
    failureUnknown: 'Årsagen er ukendt. Test forbindelsen for at kontrollere.',
    removeCredentialsConfirm:
      'Fjern {name}? Poneva stopper med at læse gennem forbindelsen og sletter de gemte legitimationsoplysninger. For at oprette forbindelse igen skal du indtaste dem igen. Dine chats og App-data bevares.',
    fieldRequired: 'Indtast {field}.',
    fieldTooLong: '{field} er for langt.',
    fieldInvalid: 'Kontrollér {field}.',
    testConnection: 'Test forbindelse',
    allowWriteDone: 'Skrivning tilladt i {name}',
    agentWriteNeeded:
      '{name} er sat til Læsning. Sæt den til Læsning og skrivning i Forbindelser, så denne agent kan foretage ændringer.',
    agentWriteAsk:
      '{name} er sat til Læsning, og kun ejeren eller en administrator kan ændre det. Bed dem om at sætte den til Læsning og skrivning, så denne agent kan foretage ændringer.',
    openConnections: 'Åbn Forbindelser',
    cardWriteNeeded:
      '{name} er sat til Læsning, så det kan ikke køre, før den er sat til Læsning og skrivning i Forbindelser.',
    appWritesRow: 'Denne app laver ændringer i {name}',
    agentWritesRow: 'Denne agent laver ændringer i {name}',
    appWritesBody:
      'Kørsler laver ændringer uden at spørge. Du kan slå det fra under Rediger adgang.',
    appWritesAllow: 'Tillad',
    cardEditAccess: 'Rediger adgang',
    cardViewAccess: 'Se adgang',
    kindPipedream: 'Pipedream-app',
    kindCustom: 'Egen forbindelse',
    kindDatabase: 'Database',
    connectedBy: 'forbundet af {person}',
    whoOnlyYou: 'Kun dig',
    whoEveryone: 'Alle i {company}',
    peopleNoun: 'one:person|other:personer',
    whatRead: 'Læsning',
    whatReadWrite: 'Læsning og skrivning',
    statusConnected: 'Forbundet',
    statusOff: 'Slået fra',
    statusReconnect: 'Skal forbindes igen',
    statusUnavailable: 'Ikke tilgængelig',
    sheetTitle: 'Adgang til {name}',
    sheetTitleConnect: 'Hvem kan bruge {name}?',
    appliesNext: 'Ændringer gælder fra næste anmodning.',
    qWho: 'Hvem kan bruge den',
    optOnlyMe: 'Kun mig',
    optOnlyMeBody: 'Kun du kan bruge den. Den vises aldrig for andre.',
    optEveryone: 'Alle i {company}',
    optEveryoneBody: 'Alle i {company} kan bruge den i deres chats og apps.',
    optPeople: 'Udvalgte personer',
    addPeople: 'Tilføj personer efter navn eller e-mail…',
    ownerTag: 'Ejer',
    peopleEmpty: 'Tilføj mindst én person, eller vælg Kun mig.',
    everyoneAdminOnly: 'Kun en ejer eller administrator kan dele med alle.',
    qWhat: 'Hvad Poneva kan gøre',
    optRead: 'Læsning',
    optReadBody: 'Poneva kan slå ting op. Den ændrer aldrig noget.',
    optReadWrite: 'Læsning og skrivning',
    optReadWriteBody: 'Poneva kan også lave ændringer. Alle ændringer registreres.',
    reach: 'Hvad den kan nå',
    actionsNoun: 'one:handling|other:handlinger',
    reachCount: '{actions} · {read} læsning · {write} skrivning',
    reachUnlabelled: 'Handlinger, som tjenesten ikke mærker, tælles som ændringer.',
    reachDatabase:
      'Poneva kan læse alt, hvad dette databaselogin kan se. Hvis du vil dele mindre, så forbind med et login, der kun har adgang til det, du vil dele.',
    turnOff: 'Slå adgang fra',
    turnOffConfirm:
      'Vil du slå {name} fra? Ingen kan bruge den, før den slås til igen. Intet slettes.',
    remove: 'Fjern forbindelse',
    removeConfirm:
      'Vil du fjerne {name}? Det sletter det login, Poneva har gemt. Chats og apps, der brugte den, holder op med at virke. Data, der allerede er vist eller gemt i apps, bliver, hvor de er.',
    readOnlyNote: 'Kun {owner} eller en administrator kan ændre dette.',
    saved: 'Adgang opdateret. Gælder fra næste anmodning.',
    conflict: 'En anden har ændret dette. Her er den aktuelle indstilling.',
    saveFailed: 'Kunne ikke gemme. Prøv igen.',
    yourAccess: 'Din adgang',
    ownWrite: 'Poneva kan skrive til {name} for dig. Du tillod det den {date}.',
    ownWriteStop: 'Stop skrivning for mig',
    ownWriteStopConfirm:
      'Skal Poneva stoppe med at skrive til {name} for dig? Kun ejeren eller en administrator kan slå skrivning til igen.',
    ownWriteStopYes: 'Stop skrivning',
    ownWriteKeep: 'Behold',
    ownRead: 'Poneva kan læse {name} for dig. Den ændrer intet, så længe den er sat til Læsning.',
    audienceWrite: 'Skrivning er tilladt for alle, der kan bruge {name}.',
    onlyRead: 'Poneva kan kun læse {name}.',
    youSuffix: '(dig)',
    forEveryone: '{what} for alle',
    activityTitle: 'Aktivitet',
    activityEmpty: 'Ingen aktivitet endnu. Hver gang Poneva bruger en forbindelse, vises det her.',
  },
  de: {
    turnOn: 'Zugriff aktivieren',
    turnOnConfirm: '{name} mit dem oben angezeigten Zugriff aktivieren?',
    failureUnknown: 'Der Grund ist unbekannt. Testen Sie die Verbindung.',
    removeCredentialsConfirm:
      '{name} entfernen? Poneva liest nicht mehr über diese Verbindung und löscht die gespeicherten Zugangsdaten. Zum erneuten Verbinden geben Sie sie wieder ein. Ihre Chats und App-Daten bleiben erhalten.',
    fieldRequired: 'Geben Sie {field} ein.',
    fieldTooLong: '{field} ist zu lang.',
    fieldInvalid: 'Prüfen Sie {field}.',
    testConnection: 'Verbindung testen',
    allowWriteDone: 'Schreiben in {name} erlaubt',
    agentWriteNeeded:
      '{name} ist auf Lesen eingestellt. Damit dieser Agent dort Änderungen vornehmen kann, stellen Sie es unter Verbindungen auf Lesen und Schreiben.',
    agentWriteAsk:
      '{name} ist auf Lesen eingestellt, und nur der Inhaber oder ein Admin kann das ändern. Bitten Sie sie, es auf Lesen und Schreiben zu stellen, damit dieser Agent dort Änderungen vornehmen kann.',
    openConnections: 'Verbindungen öffnen',
    cardWriteNeeded:
      '{name} ist auf Lesen eingestellt, daher kann das erst ausgeführt werden, wenn es unter Verbindungen auf Lesen und Schreiben eingestellt ist.',
    appWritesRow: 'Diese App nimmt Änderungen in {name} vor',
    agentWritesRow: 'Dieser Agent nimmt Änderungen in {name} vor',
    appWritesBody:
      'Ausführungen nehmen Änderungen vor, ohne zu fragen. Sie können das unter „Zugriff bearbeiten“ ausschalten.',
    appWritesAllow: 'Erlauben',
    cardEditAccess: 'Zugriff bearbeiten',
    cardViewAccess: 'Zugriff ansehen',
    kindPipedream: 'Pipedream-App',
    kindCustom: 'Eigene Verbindung',
    kindDatabase: 'Datenbank',
    connectedBy: 'verbunden von {person}',
    whoOnlyYou: 'Nur Sie',
    whoEveryone: 'Alle bei {company}',
    peopleNoun: 'one:Person|other:Personen',
    whatRead: 'Lesen',
    whatReadWrite: 'Lesen und Schreiben',
    statusConnected: 'Verbunden',
    statusOff: 'Ausgeschaltet',
    statusReconnect: 'Neu verbinden nötig',
    statusUnavailable: 'Nicht verfügbar',
    sheetTitle: 'Zugriff auf {name}',
    sheetTitleConnect: 'Wer kann {name} verwenden?',
    appliesNext: 'Änderungen gelten ab der nächsten Anfrage.',
    qWho: 'Wer sie verwenden kann',
    optOnlyMe: 'Nur ich',
    optOnlyMeBody: 'Nur Sie können sie verwenden. Sie ist für niemanden sonst sichtbar.',
    optEveryone: 'Alle bei {company}',
    optEveryoneBody: 'Alle bei {company} können sie in ihren Chats und Apps verwenden.',
    optPeople: 'Bestimmte Personen',
    addPeople: 'Personen nach Name oder E-Mail hinzufügen…',
    ownerTag: 'Inhaber',
    peopleEmpty: 'Fügen Sie mindestens eine Person hinzu oder wählen Sie „Nur ich“.',
    everyoneAdminOnly: 'Nur ein Inhaber oder Admin kann mit allen teilen.',
    qWhat: 'Was Poneva tun kann',
    optRead: 'Lesen',
    optReadBody: 'Poneva kann Dinge nachschlagen. Poneva ändert nie etwas.',
    optReadWrite: 'Lesen und Schreiben',
    optReadWriteBody: 'Poneva kann auch Änderungen vornehmen. Jede Änderung wird protokolliert.',
    reach: 'Worauf Poneva zugreifen kann',
    actionsNoun: 'one:Aktion|other:Aktionen',
    reachCount: '{actions} · {read} lesend · {write} schreibend',
    reachUnlabelled: 'Aktionen, die der Dienst nicht kennzeichnet, zählen als Änderungen.',
    reachDatabase:
      'Poneva kann alles lesen, was dieser Datenbank-Login sehen kann. Um weniger zu teilen, verbinden Sie sich mit einem Login, das nur Zugriff auf das hat, was Sie teilen möchten.',
    turnOff: 'Zugriff ausschalten',
    turnOffConfirm:
      '{name} ausschalten? Niemand kann die Verbindung verwenden, bis sie wieder eingeschaltet wird. Es wird nichts gelöscht.',
    remove: 'Verbindung entfernen',
    removeConfirm:
      '{name} entfernen? Dadurch wird die von Poneva gespeicherte Anmeldung gelöscht. Chats und Apps, die die Verbindung verwendet haben, funktionieren nicht mehr. Bereits angezeigte oder in Apps gespeicherte Daten bleiben, wo sie sind.',
    readOnlyNote: 'Nur {owner} oder ein Admin kann das ändern.',
    saved: 'Zugriff aktualisiert. Gilt ab der nächsten Anfrage.',
    conflict: 'Jemand anderes hat das geändert. Hier ist die aktuelle Einstellung.',
    saveFailed: 'Speichern fehlgeschlagen. Versuchen Sie es erneut.',
    yourAccess: 'Ihr Zugriff',
    ownWrite: 'Poneva kann für Sie in {name} schreiben. Sie haben das am {date} erlaubt.',
    ownWriteStop: 'Schreiben für mich beenden',
    ownWriteStopConfirm:
      'Soll Poneva nicht mehr für Sie in {name} schreiben? Nur der Inhaber oder ein Admin kann das Schreiben wieder aktivieren.',
    ownWriteStopYes: 'Schreiben beenden',
    ownWriteKeep: 'Beibehalten',
    ownRead:
      'Poneva kann {name} für Sie lesen. Solange es auf Lesen eingestellt ist, ändert Poneva dort nichts.',
    audienceWrite: 'Schreiben ist für alle erlaubt, die {name} verwenden können.',
    onlyRead: 'Poneva kann {name} nur lesen.',
    youSuffix: '(Sie)',
    forEveryone: '{what}, für alle',
    activityTitle: 'Aktivität',
    activityEmpty:
      'Noch keine Aktivität. Jedes Mal, wenn Poneva eine Verbindung verwendet, erscheint das hier.',
  },
  el: {
    turnOn: 'Ενεργοποίηση πρόσβασης',
    turnOnConfirm: 'Να ενεργοποιηθεί το {name} με την πρόσβαση που φαίνεται παραπάνω;',
    failureUnknown: 'Η αιτία είναι άγνωστη. Δοκιμάστε τη σύνδεση για έλεγχο.',
    removeCredentialsConfirm:
      'Να αφαιρεθεί το {name}; Το Poneva σταματά να διαβάζει μέσω αυτής της σύνδεσης και διαγράφει τα αποθηκευμένα στοιχεία σύνδεσης. Για επανασύνδεση θα τα εισαγάγετε ξανά. Οι συνομιλίες και τα δεδομένα App σας παραμένουν.',
    fieldRequired: 'Συμπληρώστε {field}.',
    fieldTooLong: 'Το {field} είναι πολύ μεγάλο.',
    fieldInvalid: 'Ελέγξτε το {field}.',
    testConnection: 'Δοκιμή σύνδεσης',
    allowWriteDone: 'Η εγγραφή στο {name} επιτρέπεται',
    agentWriteNeeded:
      'Το {name} έχει οριστεί σε Ανάγνωση. Για να μπορεί αυτός ο πράκτορας να κάνει αλλαγές, ορίστε το σε Ανάγνωση και εγγραφή στις Συνδέσεις.',
    agentWriteAsk:
      'Το {name} έχει οριστεί σε Ανάγνωση και μόνο ο κάτοχός του ή ένας διαχειριστής μπορεί να το αλλάξει. Ζητήστε τους να το ορίσουν σε Ανάγνωση και εγγραφή, ώστε αυτός ο πράκτορας να μπορεί να κάνει αλλαγές.',
    openConnections: 'Άνοιγμα Συνδέσεων',
    cardWriteNeeded:
      'Το {name} έχει οριστεί σε Ανάγνωση, οπότε αυτό δεν μπορεί να εκτελεστεί μέχρι να οριστεί σε Ανάγνωση και εγγραφή στις Συνδέσεις.',
    appWritesRow: 'Αυτή η εφαρμογή κάνει αλλαγές στο {name}',
    agentWritesRow: 'Αυτός ο πράκτορας κάνει αλλαγές στο {name}',
    appWritesBody:
      'Οι εκτελέσεις θα κάνουν αλλαγές χωρίς να ρωτούν. Μπορείτε να το απενεργοποιήσετε στην Επεξεργασία πρόσβασης.',
    appWritesAllow: 'Να επιτρέπεται',
    cardEditAccess: 'Επεξεργασία πρόσβασης',
    cardViewAccess: 'Προβολή πρόσβασης',
    kindPipedream: 'Εφαρμογή Pipedream',
    kindCustom: 'Προσαρμοσμένη σύνδεση',
    kindDatabase: 'Βάση δεδομένων',
    connectedBy: 'συνδέθηκε από: {person}',
    whoOnlyYou: 'Μόνο εσείς',
    whoEveryone: 'Όλοι στην εταιρεία {company}',
    peopleNoun: 'one:άτομο|other:άτομα',
    whatRead: 'Ανάγνωση',
    whatReadWrite: 'Ανάγνωση και εγγραφή',
    statusConnected: 'Συνδεδεμένη',
    statusOff: 'Απενεργοποιημένη',
    statusReconnect: 'Χρειάζεται επανασύνδεση',
    statusUnavailable: 'Μη διαθέσιμη',
    sheetTitle: 'Πρόσβαση στο {name}',
    sheetTitleConnect: 'Ποιος μπορεί να χρησιμοποιεί το {name};',
    appliesNext: 'Οι αλλαγές ισχύουν από το επόμενο αίτημα.',
    qWho: 'Ποιος μπορεί να τη χρησιμοποιεί',
    optOnlyMe: 'Μόνο εγώ',
    optOnlyMeBody:
      'Μόνο εσείς μπορείτε να τη χρησιμοποιείτε. Δεν εμφανίζεται ποτέ σε κανέναν άλλον.',
    optEveryone: 'Όλοι στην εταιρεία {company}',
    optEveryoneBody:
      'Όλοι στην εταιρεία {company} μπορούν να τη χρησιμοποιούν στις συνομιλίες και τις εφαρμογές τους.',
    optPeople: 'Συγκεκριμένα άτομα',
    addPeople: 'Προσθέστε άτομα με όνομα ή email…',
    ownerTag: 'Κάτοχος',
    peopleEmpty: 'Προσθέστε τουλάχιστον ένα άτομο ή επιλέξτε «Μόνο εγώ».',
    everyoneAdminOnly: 'Μόνο ένας κάτοχος ή διαχειριστής μπορεί να κάνει κοινοποίηση σε όλους.',
    qWhat: 'Τι μπορεί να κάνει το Poneva',
    optRead: 'Ανάγνωση',
    optReadBody: 'Το Poneva μπορεί να αναζητά πληροφορίες. Δεν αλλάζει ποτέ τίποτα.',
    optReadWrite: 'Ανάγνωση και εγγραφή',
    optReadWriteBody: 'Το Poneva μπορεί επίσης να κάνει αλλαγές. Κάθε αλλαγή καταγράφεται.',
    reach: 'Σε τι έχει πρόσβαση',
    actionsNoun: 'one:ενέργεια|other:ενέργειες',
    reachCount: '{actions} · {read} ανάγνωσης · {write} εγγραφής',
    reachUnlabelled: 'Οι ενέργειες που η υπηρεσία δεν επισημαίνει μετρώνται ως αλλαγές.',
    reachDatabase:
      'Το Poneva μπορεί να διαβάζει ό,τι βλέπει αυτός ο λογαριασμός της βάσης δεδομένων. Για να μοιράζεστε λιγότερα, συνδεθείτε με έναν λογαριασμό που έχει πρόσβαση μόνο σε όσα θέλετε να μοιραστείτε.',
    turnOff: 'Απενεργοποίηση πρόσβασης',
    turnOffConfirm:
      'Απενεργοποίηση του {name}; Κανείς δεν μπορεί να το χρησιμοποιήσει μέχρι να ενεργοποιηθεί ξανά. Δεν διαγράφεται τίποτα.',
    remove: 'Κατάργηση σύνδεσης',
    removeConfirm:
      'Κατάργηση του {name}; Θα διαγραφεί η σύνδεση λογαριασμού που αποθήκευσε το Poneva. Οι συνομιλίες και οι εφαρμογές που το χρησιμοποιούσαν θα σταματήσουν να λειτουργούν. Τα δεδομένα που έχουν ήδη εμφανιστεί ή αποθηκευτεί σε εφαρμογές μένουν εκεί που είναι.',
    readOnlyNote: 'Μόνο {owner} ή ένας διαχειριστής μπορεί να το αλλάξει.',
    saved: 'Η πρόσβαση ενημερώθηκε. Ισχύει από το επόμενο αίτημα.',
    conflict: 'Κάποιος άλλος το άλλαξε. Αυτή είναι η τρέχουσα ρύθμιση.',
    saveFailed: 'Δεν ήταν δυνατή η αποθήκευση. Δοκιμάστε ξανά.',
    yourAccess: 'Η πρόσβασή σας',
    ownWrite: 'Το Poneva μπορεί να γράφει στο {name} για εσάς. Το επιτρέψατε στις {date}.',
    ownWriteStop: 'Διακοπή εγγραφής για μένα',
    ownWriteStopConfirm:
      'Να σταματήσει το Poneva να γράφει στο {name} για εσάς; Μόνο ο κάτοχος ή ένας διαχειριστής μπορεί να ενεργοποιήσει ξανά την εγγραφή.',
    ownWriteStopYes: 'Διακοπή εγγραφής',
    ownWriteKeep: 'Διατήρηση',
    ownRead:
      'Το Poneva μπορεί να διαβάζει το {name} για εσάς. Όσο είναι ρυθμισμένο σε Ανάγνωση, δεν αλλάζει τίποτα εκεί.',
    audienceWrite: 'Η εγγραφή επιτρέπεται για όλους όσοι μπορούν να χρησιμοποιούν το {name}.',
    onlyRead: 'Το Poneva μπορεί μόνο να διαβάζει το {name}.',
    youSuffix: '(εσείς)',
    forEveryone: '{what}, για όλους',
    activityTitle: 'Δραστηριότητα',
    activityEmpty:
      'Δεν υπάρχει δραστηριότητα ακόμη. Κάθε φορά που το Poneva χρησιμοποιεί μια σύνδεση, εμφανίζεται εδώ.',
  },
  en: {
    turnOn: 'Turn on access',
    turnOnConfirm: 'Turn on {name} with the access shown above?',
    failureUnknown: 'The reason is unknown. Test connection to check.',
    removeCredentialsConfirm:
      'Remove {name}? Poneva stops reading through it and deletes its stored credentials. To reconnect, you’ll enter the credentials again. Your chats and App data stay.',
    fieldRequired: 'Enter {field}.',
    fieldTooLong: '{field} is too long.',
    fieldInvalid: 'Check {field}.',
    testConnection: 'Test connection',
    allowWriteDone: 'Writing allowed in {name}',
    agentWriteNeeded:
      '{name} is set to Read. To let this agent make changes there, set it to Read & write in Connections.',
    agentWriteAsk:
      '{name} is set to Read, and only its owner or an admin can change that. Ask them to set it to Read & write so this agent can make changes there.',
    openConnections: 'Open Connections',
    cardWriteNeeded:
      '{name} is set to Read, so this can’t run until it is set to Read & write in Connections.',
    appWritesRow: 'This App makes changes in {name}',
    agentWritesRow: 'This agent makes changes in {name}',
    appWritesBody: 'Runs will make changes without asking. You can turn this off in Edit access.',
    appWritesAllow: 'Allow',
    cardEditAccess: 'Edit access',
    cardViewAccess: 'View access',
    kindPipedream: 'Pipedream app',
    kindCustom: 'Custom connection',
    kindDatabase: 'Database',
    connectedBy: 'connected by {person}',
    whoOnlyYou: 'Only you',
    whoEveryone: 'Everyone at {company}',
    peopleNoun: 'one:person|other:people',
    whatRead: 'Read',
    whatReadWrite: 'Read & write',
    statusConnected: 'Connected',
    statusOff: 'Turned off',
    statusReconnect: 'Needs reconnect',
    statusUnavailable: 'Not available',
    sheetTitle: 'Access to {name}',
    sheetTitleConnect: 'Who can use {name}?',
    appliesNext: 'Changes apply to the next request.',
    qWho: 'Who can use it',
    optOnlyMe: 'Only me',
    optOnlyMeBody: 'Only you can use it. It never appears to anyone else.',
    optEveryone: 'Everyone at {company}',
    optEveryoneBody: 'Anyone in {company} can use it in their chats and Apps.',
    optPeople: 'Specific people',
    addPeople: 'Add people by name or email…',
    ownerTag: 'Owner',
    peopleEmpty: 'Add at least one person, or choose Only me.',
    everyoneAdminOnly: 'Only an Owner or Admin can share with everyone.',
    qWhat: 'What Poneva can do',
    optRead: 'Read',
    optReadBody: 'Poneva can look things up. It never changes anything.',
    optReadWrite: 'Read & write',
    optReadWriteBody: 'Poneva can also make changes. Every change is recorded.',
    reach: 'What it can reach',
    actionsNoun: 'one:action|other:actions',
    reachCount: '{actions} · {read} read · {write} write',
    reachUnlabelled: "Actions the service doesn't label count as changes.",
    reachDatabase:
      'Poneva can read whatever this database login can see. To share less, connect with a login that only has access to what you want shared.',
    turnOff: 'Turn off access',
    turnOffConfirm:
      "Turn off {name}? Nobody can use it until it's turned back on. Nothing is deleted.",
    remove: 'Remove connection',
    removeConfirm:
      'Remove {name}? This deletes the sign-in Poneva saved. Chats and Apps that used it stop working. Data already shown or saved in Apps stays where it is.',
    readOnlyNote: 'Only {owner} or an Admin can change this.',
    saved: 'Access updated. Applies to the next request.',
    conflict: "Someone else changed this. Here's the current setting.",
    saveFailed: "Couldn't save. Try again.",
    yourAccess: 'Your access',
    ownWrite: 'Poneva can write to {name} for you. You allowed this on {date}.',
    ownWriteStop: 'Stop writing for me',
    ownWriteStopConfirm:
      'Stop Poneva writing to {name} for you? Only its owner or an admin can turn writing on again.',
    ownWriteStopYes: 'Stop writing',
    ownWriteKeep: 'Keep',
    ownRead: 'Poneva can read {name} for you. It changes nothing there while it is set to Read.',
    audienceWrite: 'Writing is allowed for everyone who can use {name}.',
    onlyRead: 'Poneva can only read {name}.',
    youSuffix: '(you)',
    forEveryone: '{what}, for everyone',
    activityTitle: 'Activity',
    activityEmpty: 'No activity yet. Every time Poneva uses a connection, it shows up here.',
  },
  es: {
    turnOn: 'Activar acceso',
    turnOnConfirm: '¿Activar {name} con el acceso mostrado arriba?',
    failureUnknown: 'El motivo es desconocido. Prueba la conexión para comprobarlo.',
    removeCredentialsConfirm:
      '¿Eliminar {name}? Poneva deja de leer a través de esta conexión y borra las credenciales guardadas. Para volver a conectar, tendrás que introducirlas de nuevo. Tus chats y datos de Apps se conservan.',
    fieldRequired: 'Introduce {field}.',
    fieldTooLong: '{field} es demasiado largo.',
    fieldInvalid: 'Comprueba {field}.',
    testConnection: 'Probar conexión',
    allowWriteDone: 'Escritura permitida en {name}',
    agentWriteNeeded:
      '{name} está en Lectura. Para que este agente pueda hacer cambios, cámbialo a Lectura y escritura en Conexiones.',
    agentWriteAsk:
      '{name} está en Lectura y solo su propietario o un administrador puede cambiarlo. Pídeles que lo cambien a Lectura y escritura para que este agente pueda hacer cambios.',
    openConnections: 'Abrir Conexiones',
    cardWriteNeeded:
      '{name} está en Lectura, así que esto no se puede ejecutar hasta que se cambie a Lectura y escritura en Conexiones.',
    appWritesRow: 'Esta app hace cambios en {name}',
    agentWritesRow: 'Este agente hace cambios en {name}',
    appWritesBody:
      'Las ejecuciones harán cambios sin preguntar. Puedes desactivarlo en Editar acceso.',
    appWritesAllow: 'Permitir',
    cardEditAccess: 'Editar acceso',
    cardViewAccess: 'Ver acceso',
    kindPipedream: 'App de Pipedream',
    kindCustom: 'Conexión personalizada',
    kindDatabase: 'Base de datos',
    connectedBy: 'conectada por {person}',
    whoOnlyYou: 'Solo tú',
    whoEveryone: 'Todos en {company}',
    peopleNoun: 'one:persona|other:personas',
    whatRead: 'Lectura',
    whatReadWrite: 'Lectura y escritura',
    statusConnected: 'Conectada',
    statusOff: 'Desactivada',
    statusReconnect: 'Hay que volver a conectar',
    statusUnavailable: 'No disponible',
    sheetTitle: 'Acceso a {name}',
    sheetTitleConnect: '¿Quién puede usar {name}?',
    appliesNext: 'Los cambios se aplican a la próxima solicitud.',
    qWho: 'Quién puede usarla',
    optOnlyMe: 'Solo yo',
    optOnlyMeBody: 'Solo tú puedes usarla. Nunca aparece para nadie más.',
    optEveryone: 'Todos en {company}',
    optEveryoneBody: 'Cualquier persona de {company} puede usarla en sus chats y apps.',
    optPeople: 'Personas concretas',
    addPeople: 'Añade personas por nombre o correo electrónico…',
    ownerTag: 'Propietario',
    peopleEmpty: 'Añade al menos una persona o elige Solo yo.',
    everyoneAdminOnly: 'Solo un propietario o administrador puede compartir con todos.',
    qWhat: 'Qué puede hacer Poneva',
    optRead: 'Lectura',
    optReadBody: 'Poneva puede consultar información. Nunca cambia nada.',
    optReadWrite: 'Lectura y escritura',
    optReadWriteBody: 'Poneva también puede hacer cambios. Cada cambio queda registrado.',
    reach: 'A qué puede acceder',
    actionsNoun: 'one:acción|other:acciones',
    reachCount: '{actions} · {read} de lectura · {write} de escritura',
    reachUnlabelled: 'Las acciones que el servicio no etiqueta cuentan como cambios.',
    reachDatabase:
      'Poneva puede leer todo lo que ve este inicio de sesión de la base de datos. Para compartir menos, conéctate con un inicio de sesión que solo tenga acceso a lo que quieres compartir.',
    turnOff: 'Desactivar acceso',
    turnOffConfirm:
      '¿Desactivar {name}? Nadie podrá usarla hasta que se vuelva a activar. No se elimina nada.',
    remove: 'Quitar conexión',
    removeConfirm:
      '¿Quitar {name}? Se eliminará el inicio de sesión que Poneva guardó. Los chats y apps que la usaban dejarán de funcionar. Los datos ya mostrados o guardados en apps se quedan donde están.',
    readOnlyNote: 'Solo {owner} o un administrador puede cambiar esto.',
    saved: 'Acceso actualizado. Se aplica a la próxima solicitud.',
    conflict: 'Otra persona ha cambiado esto. Esta es la configuración actual.',
    saveFailed: 'No se pudo guardar. Inténtalo de nuevo.',
    yourAccess: 'Tu acceso',
    ownWrite: 'Poneva puede escribir en {name} por ti. Lo permitiste el {date}.',
    ownWriteStop: 'Dejar de escribir por mí',
    ownWriteStopConfirm:
      '¿Quieres que Poneva deje de escribir en {name} por ti? Solo su propietario o un administrador puede volver a activar la escritura.',
    ownWriteStopYes: 'Dejar de escribir',
    ownWriteKeep: 'Mantener',
    ownRead: 'Poneva puede leer {name} por ti. Mientras esté en Lectura, no cambia nada allí.',
    audienceWrite: 'La escritura está permitida para todas las personas que pueden usar {name}.',
    onlyRead: 'Poneva solo puede leer {name}.',
    youSuffix: '(tú)',
    forEveryone: '{what}, para todos',
    activityTitle: 'Actividad',
    activityEmpty: 'Todavía no hay actividad. Cada vez que Poneva usa una conexión, aparece aquí.',
  },
  et: {
    turnOn: 'Lülita juurdepääs sisse',
    turnOnConfirm: 'Kas lülitada {name} sisse ülal näidatud juurdepääsuga?',
    failureUnknown: 'Põhjus on teadmata. Kontrollimiseks testi ühendust.',
    removeCredentialsConfirm:
      'Kas eemaldada {name}? Poneva lõpetab selle ühenduse kaudu lugemise ja kustutab salvestatud sisselogimisandmed. Uuesti ühendamiseks sisesta need uuesti. Sinu vestlused ja Appi andmed jäävad alles.',
    fieldRequired: 'Sisesta {field}.',
    fieldTooLong: '{field} on liiga pikk.',
    fieldInvalid: 'Kontrolli välja {field}.',
    testConnection: 'Testi ühendust',
    allowWriteDone: 'Kirjutamine lubatud: {name}',
    agentWriteNeeded:
      '{name} on seatud valikule Lugemine. Et see agent saaks seal muudatusi teha, sea see Ühendustes valikule Lugemine ja kirjutamine.',
    agentWriteAsk:
      '{name} on seatud valikule Lugemine ja seda saab muuta ainult selle omanik või administraator. Palu neil seada see valikule Lugemine ja kirjutamine, et see agent saaks seal muudatusi teha.',
    openConnections: 'Ava ühendused',
    cardWriteNeeded:
      '{name} on seatud valikule Lugemine, seega seda ei saa käivitada enne, kui see on Ühendustes seatud valikule Lugemine ja kirjutamine.',
    appWritesRow: 'See rakendus teeb muudatusi teenuses {name}',
    agentWritesRow: 'See agent teeb muudatusi teenuses {name}',
    appWritesBody:
      'Käivitused teevad muudatusi küsimata. Saad selle välja lülitada jaotises „Muuda juurdepääsu”.',
    appWritesAllow: 'Luba',
    cardEditAccess: 'Muuda juurdepääsu',
    cardViewAccess: 'Vaata juurdepääsu',
    kindPipedream: 'Pipedreami rakendus',
    kindCustom: 'Kohandatud ühendus',
    kindDatabase: 'Andmebaas',
    connectedBy: 'ühendaja: {person}',
    whoOnlyYou: 'Ainult sina',
    whoEveryone: 'Kõik ettevõttes {company}',
    peopleNoun: 'one:inimene|other:inimest',
    whatRead: 'Lugemine',
    whatReadWrite: 'Lugemine ja kirjutamine',
    statusConnected: 'Ühendatud',
    statusOff: 'Välja lülitatud',
    statusReconnect: 'Vajab uuesti ühendamist',
    statusUnavailable: 'Pole saadaval',
    sheetTitle: 'Juurdepääs: {name}',
    sheetTitleConnect: 'Kes saavad kasutada teenust {name}?',
    appliesNext: 'Muudatused kehtivad järgmisest päringust.',
    qWho: 'Kes saavad seda kasutada',
    optOnlyMe: 'Ainult mina',
    optOnlyMeBody: 'Ainult sina saad seda kasutada. See ei ilmu kunagi kellelegi teisele.',
    optEveryone: 'Kõik ettevõttes {company}',
    optEveryoneBody:
      'Igaüks ettevõttes {company} saab seda kasutada oma vestlustes ja rakendustes.',
    optPeople: 'Kindlad inimesed',
    addPeople: 'Lisa inimesi nime või e-posti järgi…',
    ownerTag: 'Omanik',
    peopleEmpty: 'Lisa vähemalt üks inimene või vali „Ainult mina”.',
    everyoneAdminOnly: 'Kõigiga saavad jagada ainult omanikud ja administraatorid.',
    qWhat: 'Mida Poneva teha saab',
    optRead: 'Lugemine',
    optReadBody: 'Poneva saab asju järele vaadata. See ei muuda kunagi midagi.',
    optReadWrite: 'Lugemine ja kirjutamine',
    optReadWriteBody: 'Poneva saab ka muudatusi teha. Iga muudatus salvestatakse.',
    reach: 'Millele see ligi pääseb',
    actionsNoun: 'one:toiming|other:toimingut',
    reachCount: '{actions} · lugemine: {read} · kirjutamine: {write}',
    reachUnlabelled: 'Toiminguid, mida teenus ei märgista, loetakse muudatusteks.',
    reachDatabase:
      'Poneva saab lugeda kõike, mida see andmebaasi kasutaja näeb. Vähem jagamiseks ühenda kasutajaga, kellel on juurdepääs ainult sellele, mida soovid jagada.',
    turnOff: 'Lülita juurdepääs välja',
    turnOffConfirm:
      'Kas lülitada {name} välja? Keegi ei saa seda kasutada, kuni see uuesti sisse lülitatakse. Midagi ei kustutata.',
    remove: 'Eemalda ühendus',
    removeConfirm:
      'Kas eemaldada {name}? See kustutab Poneva salvestatud sisselogimise. Seda kasutanud vestlused ja rakendused lakkavad töötamast. Juba näidatud või rakendustesse salvestatud andmed jäävad alles.',
    readOnlyNote: 'Seda saavad muuta ainult {owner} või administraator.',
    saved: 'Juurdepääs uuendatud. Kehtib järgmisest päringust.',
    conflict: 'Keegi teine muutis seda. Siin on praegune seade.',
    saveFailed: 'Salvestamine ebaõnnestus. Proovi uuesti.',
    yourAccess: 'Sinu juurdepääs',
    ownWrite: 'Poneva saab sinu nimel kirjutada teenusesse {name}. Lubasid selle kuupäeval {date}.',
    ownWriteStop: 'Lõpeta minu nimel kirjutamine',
    ownWriteStopConfirm:
      'Kas lõpetada Poneva kirjutamine teenusesse {name} sinu nimel? Kirjutamise saab uuesti sisse lülitada ainult omanik või administraator.',
    ownWriteStopYes: 'Lõpeta kirjutamine',
    ownWriteKeep: 'Jäta alles',
    ownRead:
      'Poneva saab sinu nimel lugeda teenust {name}. Kuni see on seatud valikule Lugemine, ei muuda see seal midagi.',
    audienceWrite: 'Kirjutamine on lubatud kõigile, kes saavad teenust {name} kasutada.',
    onlyRead: 'Poneva saab teenust {name} ainult lugeda.',
    youSuffix: '(sina)',
    forEveryone: '{what}, kõigile',
    activityTitle: 'Tegevus',
    activityEmpty: 'Tegevusi veel pole. Iga kord, kui Poneva ühendust kasutab, ilmub see siia.',
  },
  fi: {
    turnOn: 'Ota käyttöoikeus käyttöön',
    turnOnConfirm: 'Otetaanko {name} käyttöön yllä näytetyillä oikeuksilla?',
    failureUnknown: 'Syy ei ole tiedossa. Tarkista testaamalla yhteys.',
    removeCredentialsConfirm:
      'Poistetaanko {name}? Poneva lopettaa lukemisen tämän yhteyden kautta ja poistaa tallennetut tunnistetiedot. Yhdistääksesi uudelleen annat ne uudelleen. Keskustelusi ja App-tiedot säilyvät.',
    fieldRequired: 'Anna {field}.',
    fieldTooLong: '{field} on liian pitkä.',
    fieldInvalid: 'Tarkista {field}.',
    testConnection: 'Testaa yhteys',
    allowWriteDone: 'Kirjoittaminen sallittu: {name}',
    agentWriteNeeded:
      '{name} on asetettu tilaan Lukeminen. Jotta tämä agentti voi tehdä siihen muutoksia, aseta se Yhteyksissä tilaan Lukeminen ja kirjoittaminen.',
    agentWriteAsk:
      '{name} on asetettu tilaan Lukeminen, ja vain sen omistaja tai ylläpitäjä voi muuttaa sitä. Pyydä heitä asettamaan se tilaan Lukeminen ja kirjoittaminen, jotta tämä agentti voi tehdä siihen muutoksia.',
    openConnections: 'Avaa Yhteydet',
    cardWriteNeeded:
      '{name} on asetettu tilaan Lukeminen, joten tätä ei voi suorittaa ennen kuin se asetetaan Yhteyksissä tilaan Lukeminen ja kirjoittaminen.',
    appWritesRow: 'Tämä sovellus tekee muutoksia palvelussa {name}',
    agentWritesRow: 'Tämä agentti tekee muutoksia palvelussa {name}',
    appWritesBody:
      'Suoritukset tekevät muutoksia kysymättä. Voit poistaa tämän käytöstä kohdassa Muokkaa käyttöoikeutta.',
    appWritesAllow: 'Salli',
    cardEditAccess: 'Muokkaa käyttöoikeutta',
    cardViewAccess: 'Näytä käyttöoikeus',
    kindPipedream: 'Pipedream-sovellus',
    kindCustom: 'Mukautettu yhteys',
    kindDatabase: 'Tietokanta',
    connectedBy: 'yhdistäjä: {person}',
    whoOnlyYou: 'Vain sinä',
    whoEveryone: 'Kaikki organisaatiossa {company}',
    peopleNoun: 'one:henkilö|other:henkilöä',
    whatRead: 'Lukeminen',
    whatReadWrite: 'Lukeminen ja kirjoittaminen',
    statusConnected: 'Yhdistetty',
    statusOff: 'Poistettu käytöstä',
    statusReconnect: 'Yhdistettävä uudelleen',
    statusUnavailable: 'Ei käytettävissä',
    sheetTitle: 'Käyttöoikeus: {name}',
    sheetTitleConnect: 'Kuka voi käyttää palvelua {name}?',
    appliesNext: 'Muutokset koskevat seuraavaa pyyntöä.',
    qWho: 'Kuka voi käyttää sitä',
    optOnlyMe: 'Vain minä',
    optOnlyMeBody: 'Vain sinä voit käyttää sitä. Se ei näy koskaan kenellekään muulle.',
    optEveryone: 'Kaikki organisaatiossa {company}',
    optEveryoneBody:
      'Kuka tahansa organisaatiossa {company} voi käyttää sitä keskusteluissaan ja sovelluksissaan.',
    optPeople: 'Valitut henkilöt',
    addPeople: 'Lisää henkilöitä nimellä tai sähköpostilla…',
    ownerTag: 'Omistaja',
    peopleEmpty: 'Lisää vähintään yksi henkilö tai valitse Vain minä.',
    everyoneAdminOnly: 'Vain omistaja tai ylläpitäjä voi jakaa kaikille.',
    qWhat: 'Mitä Poneva voi tehdä',
    optRead: 'Lukeminen',
    optReadBody: 'Poneva voi hakea tietoja. Se ei koskaan muuta mitään.',
    optReadWrite: 'Lukeminen ja kirjoittaminen',
    optReadWriteBody: 'Poneva voi myös tehdä muutoksia. Jokainen muutos kirjataan.',
    reach: 'Mihin se ulottuu',
    actionsNoun: 'one:toiminto|other:toimintoa',
    reachCount: '{actions} · lukeminen: {read} · kirjoittaminen: {write}',
    reachUnlabelled: 'Toiminnot, joita palvelu ei merkitse, lasketaan muutoksiksi.',
    reachDatabase:
      'Poneva voi lukea kaiken, minkä tämä tietokantatunnus näkee. Jos haluat jakaa vähemmän, yhdistä tunnuksella, jolla on pääsy vain siihen, mitä haluat jakaa.',
    turnOff: 'Poista käyttöoikeus käytöstä',
    turnOffConfirm:
      'Poistetaanko {name} käytöstä? Kukaan ei voi käyttää sitä, ennen kuin se otetaan uudelleen käyttöön. Mitään ei poisteta.',
    remove: 'Poista yhteys',
    removeConfirm:
      'Poistetaanko {name}? Tämä poistaa Ponevan tallentaman kirjautumisen. Sitä käyttäneet keskustelut ja sovellukset lakkaavat toimimasta. Jo näytetyt tai sovelluksiin tallennetut tiedot säilyvät.',
    readOnlyNote: 'Vain {owner} tai ylläpitäjä voi muuttaa tätä.',
    saved: 'Käyttöoikeus päivitetty. Koskee seuraavaa pyyntöä.',
    conflict: 'Joku muu muutti tätä. Tässä on nykyinen asetus.',
    saveFailed: 'Tallentaminen epäonnistui. Yritä uudelleen.',
    yourAccess: 'Sinun käyttöoikeutesi',
    ownWrite: 'Poneva voi kirjoittaa palveluun {name} puolestasi. Sallit tämän {date}.',
    ownWriteStop: 'Lopeta kirjoittaminen puolestani',
    ownWriteStopConfirm:
      'Lopetetaanko Ponevan kirjoittaminen palveluun {name} puolestasi? Vain omistaja tai ylläpitäjä voi ottaa kirjoittamisen uudelleen käyttöön.',
    ownWriteStopYes: 'Lopeta kirjoittaminen',
    ownWriteKeep: 'Pidä',
    ownRead:
      'Poneva voi lukea palvelua {name} puolestasi. Niin kauan kuin se on tilassa Lukeminen, se ei muuta siellä mitään.',
    audienceWrite: 'Kirjoittaminen on sallittu kaikille, jotka voivat käyttää palvelua {name}.',
    onlyRead: 'Poneva voi vain lukea palvelua {name}.',
    youSuffix: '(sinä)',
    forEveryone: '{what}, kaikille',
    activityTitle: 'Toiminta',
    activityEmpty: 'Ei vielä toimintaa. Aina kun Poneva käyttää yhteyttä, se näkyy täällä.',
  },
  fr: {
    turnOn: 'Activer l’accès',
    turnOnConfirm: 'Activer {name} avec l’accès indiqué ci-dessus ?',
    failureUnknown: 'La raison est inconnue. Testez la connexion pour vérifier.',
    removeCredentialsConfirm:
      'Supprimer {name} ? Poneva cesse de lire via cette connexion et supprime les identifiants enregistrés. Pour vous reconnecter, vous les saisirez de nouveau. Vos chats et données des Apps restent disponibles.',
    fieldRequired: 'Saisissez {field}.',
    fieldTooLong: '{field} est trop long.',
    fieldInvalid: 'Vérifiez {field}.',
    testConnection: 'Tester la connexion',
    allowWriteDone: 'Écriture autorisée dans {name}',
    agentWriteNeeded:
      '{name} est réglé sur Lecture. Pour que cet agent puisse y apporter des modifications, réglez-le sur Lecture et écriture dans Connexions.',
    agentWriteAsk:
      '{name} est réglé sur Lecture, et seul son propriétaire ou un administrateur peut le modifier. Demandez-leur de le régler sur Lecture et écriture pour que cet agent puisse y apporter des modifications.',
    openConnections: 'Ouvrir Connexions',
    cardWriteNeeded:
      '{name} est réglé sur Lecture, cette action ne peut donc pas s’exécuter tant qu’il n’est pas réglé sur Lecture et écriture dans Connexions.',
    appWritesRow: 'Cette app apporte des modifications dans {name}',
    agentWritesRow: 'Cet agent apporte des modifications dans {name}',
    appWritesBody:
      'Les exécutions apporteront des modifications sans demander. Vous pouvez désactiver cela dans Modifier l’accès.',
    appWritesAllow: 'Autoriser',
    cardEditAccess: 'Modifier l’accès',
    cardViewAccess: 'Voir l’accès',
    kindPipedream: 'App Pipedream',
    kindCustom: 'Connexion personnalisée',
    kindDatabase: 'Base de données',
    connectedBy: 'connectée par {person}',
    whoOnlyYou: 'Vous uniquement',
    whoEveryone: 'Tout le monde chez {company}',
    peopleNoun: 'one:personne|other:personnes',
    whatRead: 'Lecture',
    whatReadWrite: 'Lecture et écriture',
    statusConnected: 'Connectée',
    statusOff: 'Désactivée',
    statusReconnect: 'À reconnecter',
    statusUnavailable: 'Indisponible',
    sheetTitle: 'Accès à {name}',
    sheetTitleConnect: 'Qui peut utiliser {name} ?',
    appliesNext: 'Les modifications s’appliquent à la prochaine requête.',
    qWho: 'Qui peut l’utiliser',
    optOnlyMe: 'Moi uniquement',
    optOnlyMeBody: 'Vous seul pouvez l’utiliser. Elle n’apparaît jamais à personne d’autre.',
    optEveryone: 'Tout le monde chez {company}',
    optEveryoneBody: 'Toute personne chez {company} peut l’utiliser dans ses chats et ses apps.',
    optPeople: 'Personnes précises',
    addPeople: 'Ajouter des personnes par nom ou e-mail…',
    ownerTag: 'Propriétaire',
    peopleEmpty: 'Ajoutez au moins une personne ou choisissez Moi uniquement.',
    everyoneAdminOnly:
      'Seul un propriétaire ou un administrateur peut partager avec tout le monde.',
    qWhat: 'Ce que Poneva peut faire',
    optRead: 'Lecture',
    optReadBody: 'Poneva peut consulter des informations. Il ne modifie jamais rien.',
    optReadWrite: 'Lecture et écriture',
    optReadWriteBody:
      'Poneva peut aussi apporter des modifications. Chaque modification est enregistrée.',
    reach: 'Ce à quoi elle donne accès',
    actionsNoun: 'one:action|other:actions',
    reachCount: '{actions} · lecture : {read} · écriture : {write}',
    reachUnlabelled: 'Les actions que le service n’étiquette pas comptent comme des modifications.',
    reachDatabase:
      'Poneva peut lire tout ce que cet identifiant de base de données peut voir. Pour partager moins, connectez-vous avec un identifiant qui n’a accès qu’à ce que vous voulez partager.',
    turnOff: 'Désactiver l’accès',
    turnOffConfirm:
      'Désactiver {name} ? Personne ne pourra l’utiliser tant qu’elle n’est pas réactivée. Rien n’est supprimé.',
    remove: 'Supprimer la connexion',
    removeConfirm:
      'Supprimer {name} ? Cela supprime la connexion enregistrée par Poneva. Les chats et les apps qui l’utilisaient cessent de fonctionner. Les données déjà affichées ou enregistrées dans les apps restent en place.',
    readOnlyNote: 'Seul {owner} ou un administrateur peut modifier ceci.',
    saved: 'Accès mis à jour. S’applique à la prochaine requête.',
    conflict: 'Quelqu’un d’autre a modifié ceci. Voici le réglage actuel.',
    saveFailed: 'Impossible d’enregistrer. Réessayez.',
    yourAccess: 'Votre accès',
    ownWrite: 'Poneva peut écrire dans {name} pour vous. Vous l’avez autorisé le {date}.',
    ownWriteStop: 'Ne plus écrire pour moi',
    ownWriteStopConfirm:
      'Empêcher Poneva d’écrire dans {name} pour vous ? Seul son propriétaire ou un administrateur peut réactiver l’écriture.',
    ownWriteStopYes: 'Arrêter l’écriture',
    ownWriteKeep: 'Conserver',
    ownRead:
      'Poneva peut lire {name} pour vous. Tant qu’il est réglé sur Lecture, Poneva n’y modifie rien.',
    audienceWrite:
      'L’écriture est autorisée pour toutes les personnes qui peuvent utiliser {name}.',
    onlyRead: 'Poneva peut seulement lire {name}.',
    youSuffix: '(vous)',
    forEveryone: '{what}, pour tout le monde',
    activityTitle: 'Activité',
    activityEmpty:
      'Aucune activité pour le moment. Chaque fois que Poneva utilise une connexion, elle apparaît ici.',
  },
  ga: {
    turnOn: 'Cuir rochtain ar siúl',
    turnOnConfirm: 'An gcuirfear {name} ar siúl leis an rochtain thuas?',
    failureUnknown: 'Ní fios an chúis. Tástáil an nasc lena sheiceáil.',
    removeCredentialsConfirm:
      'Bain {name}? Stopann Poneva ag léamh tríd an nasc seo agus scriosann sé na dintiúir stóráilte. Chun athcheangal, iontráil arís iad. Fanann do chomhráite agus sonraí App.',
    fieldRequired: 'Iontráil {field}.',
    fieldTooLong: 'Tá {field} rófhada.',
    fieldInvalid: 'Seiceáil {field}.',
    testConnection: 'Tástáil an nasc',
    allowWriteDone: 'Scríobh ceadaithe: {name}',
    agentWriteNeeded:
      'Tá {name} socraithe ar Léamh. Chun go bhféadfaidh an gníomhaire seo athruithe a dhéanamh, socraigh é ar Léamh agus scríobh i gCeangail.',
    agentWriteAsk:
      'Tá {name} socraithe ar Léamh, agus ní féidir é sin a athrú ach ag an úinéir nó ag riarthóir. Iarr orthu é a shocrú ar Léamh agus scríobh ionas go bhféadfaidh an gníomhaire seo athruithe a dhéanamh.',
    openConnections: 'Oscail Ceangail',
    cardWriteNeeded:
      'Tá {name} socraithe ar Léamh, mar sin ní féidir é seo a rith go dtí go socraítear é ar Léamh agus scríobh i gCeangail.',
    appWritesRow: 'Déanann an aip seo athruithe in {name}',
    agentWritesRow: 'Déanann an gníomhaire seo athruithe in {name}',
    appWritesBody:
      'Déanfaidh ritheanna athruithe gan fiafraí. Is féidir leat é seo a mhúchadh in Cuir rochtain in eagar.',
    appWritesAllow: 'Ceadaigh',
    cardEditAccess: 'Cuir rochtain in eagar',
    cardViewAccess: 'Féach ar rochtain',
    kindPipedream: 'Aip Pipedream',
    kindCustom: 'Ceangal saincheaptha',
    kindDatabase: 'Bunachar sonraí',
    connectedBy: 'ceangailte ag: {person}',
    whoOnlyYou: 'Tusa amháin',
    whoEveryone: 'Gach duine in {company}',
    peopleNoun: 'one:duine|two:dhuine|few:dhuine|many:nduine|other:duine',
    whatRead: 'Léamh',
    whatReadWrite: 'Léamh agus scríobh',
    statusConnected: 'Ceangailte',
    statusOff: 'Múchta',
    statusReconnect: 'Ní mór é a athcheangal',
    statusUnavailable: 'Níl sé ar fáil',
    sheetTitle: 'Rochtain ar: {name}',
    sheetTitleConnect: 'Cé a fhéadann {name} a úsáid?',
    appliesNext: 'Bíonn athruithe i bhfeidhm ón gcéad iarratas eile.',
    qWho: 'Cé a fhéadann é a úsáid',
    optOnlyMe: 'Mise amháin',
    optOnlyMeBody:
      'Ní féidir é a úsáid ach agatsa. Ní thaispeántar riamh é do dhuine ar bith eile.',
    optEveryone: 'Gach duine in {company}',
    optEveryoneBody:
      'Is féidir le duine ar bith in {company} é a úsáid ina gcomhráite agus ina n-aipeanna.',
    optPeople: 'Daoine áirithe',
    addPeople: 'Cuir daoine leis de réir ainm nó ríomhphoist…',
    ownerTag: 'Úinéir',
    peopleEmpty: 'Cuir duine amháin ar a laghad leis, nó roghnaigh Mise amháin.',
    everyoneAdminOnly: 'Ní féidir ach le hÚinéir nó le Riarthóir comhroinnt le gach duine.',
    qWhat: 'Cad is féidir le Poneva a dhéanamh',
    optRead: 'Léamh',
    optReadBody: 'Is féidir le Poneva rudaí a chuardach. Ní athraíonn sé rud ar bith riamh.',
    optReadWrite: 'Léamh agus scríobh',
    optReadWriteBody: 'Is féidir le Poneva athruithe a dhéanamh freisin. Taifeadtar gach athrú.',
    reach: 'Cad is féidir leis a bhaint amach',
    actionsNoun: 'one:gníomh|two:ghníomh|few:ghníomh|many:ngníomh|other:gníomh',
    reachCount: '{actions} · léamh: {read} · scríobh: {write}',
    reachUnlabelled: 'Áirítear gníomhartha nach lipéadaíonn an tseirbhís mar athruithe.',
    reachDatabase:
      'Is féidir le Poneva aon rud a fheiceann an logáil isteach bunachair sonraí seo a léamh. Chun níos lú a chomhroinnt, ceangail le logáil isteach nach bhfuil rochtain aige ach ar an méid is mian leat a chomhroinnt.',
    turnOff: 'Múch rochtain',
    turnOffConfirm:
      'Múch {name}? Ní féidir le duine ar bith é a úsáid go dtí go gcastar air arís é. Ní scriostar aon rud.',
    remove: 'Bain an ceangal',
    removeConfirm:
      'Bain {name}? Scriosann sé seo an logáil isteach a shábháil Poneva. Stopfaidh comhráite agus aipeanna a d’úsáid é ag obair. Fanfaidh sonraí a taispeánadh cheana nó a sábháladh in aipeanna mar atá.',
    readOnlyNote: 'Ní féidir é seo a athrú ach ag {owner} nó ag Riarthóir.',
    saved: 'Nuashonraíodh an rochtain. Bíonn sí i bhfeidhm ón gcéad iarratas eile.',
    conflict: 'D’athraigh duine eile é seo. Seo an socrú reatha.',
    saveFailed: 'Níorbh fhéidir é a shábháil. Bain triail eile as.',
    yourAccess: 'Do rochtain',
    ownWrite: 'Is féidir le Poneva scríobh chuig {name} ar do shon. Cheadaigh tú é seo ar: {date}.',
    ownWriteStop: 'Stop ag scríobh ar mo shon',
    ownWriteStopConfirm:
      'Stop Poneva ó bheith ag scríobh chuig {name} ar do shon? Ní féidir scríobh a chasadh air arís ach ag an úinéir nó ag riarthóir.',
    ownWriteStopYes: 'Stop ag scríobh',
    ownWriteKeep: 'Coinnigh',
    ownRead:
      'Is féidir le Poneva {name} a léamh ar do shon. Ní athraíonn sé aon rud ann fad atá sé socraithe ar Léamh.',
    audienceWrite: 'Tá scríobh ceadaithe do gach duine a fhéadann {name} a úsáid.',
    onlyRead: 'Ní féidir le Poneva ach {name} a léamh.',
    youSuffix: '(tusa)',
    forEveryone: '{what}, do gach duine',
    activityTitle: 'Gníomhaíocht',
    activityEmpty:
      'Níl aon ghníomhaíocht ann fós. Gach uair a úsáideann Poneva ceangal, taispeántar anseo é.',
  },
  hr: {
    turnOn: 'Uključi pristup',
    turnOnConfirm: 'Uključiti {name} s gore prikazanim pristupom?',
    failureUnknown: 'Razlog nije poznat. Provjerite ga testiranjem veze.',
    removeCredentialsConfirm:
      'Ukloniti {name}? Poneva prestaje čitati putem ove veze i briše spremljene podatke za prijavu. Za ponovno povezivanje unijet ćete ih opet. Vaši razgovori i podaci App ostaju.',
    fieldRequired: 'Unesite {field}.',
    fieldTooLong: '{field} je predugo.',
    fieldInvalid: 'Provjerite {field}.',
    testConnection: 'Testiraj vezu',
    allowWriteDone: 'Pisanje dopušteno: {name}',
    agentWriteNeeded:
      '{name} je postavljen na Čitanje. Da bi ovaj agent mogao unositi promjene, postavite ga na Čitanje i pisanje u Vezama.',
    agentWriteAsk:
      '{name} je postavljen na Čitanje i to može promijeniti samo njegov vlasnik ili administrator. Zamolite ih da ga postave na Čitanje i pisanje kako bi ovaj agent mogao unositi promjene.',
    openConnections: 'Otvori Veze',
    cardWriteNeeded:
      '{name} je postavljen na Čitanje pa se ovo ne može izvršiti dok se u Vezama ne postavi na Čitanje i pisanje.',
    appWritesRow: 'Ova aplikacija unosi promjene u usluzi {name}',
    agentWritesRow: 'Ovaj agent unosi promjene u usluzi {name}',
    appWritesBody:
      'Pokretanja će unositi promjene bez pitanja. To možete isključiti u odjeljku Uredi pristup.',
    appWritesAllow: 'Dopusti',
    cardEditAccess: 'Uredi pristup',
    cardViewAccess: 'Prikaži pristup',
    kindPipedream: 'Pipedream aplikacija',
    kindCustom: 'Prilagođena veza',
    kindDatabase: 'Baza podataka',
    connectedBy: 'povezala osoba {person}',
    whoOnlyYou: 'Samo vi',
    whoEveryone: 'Svi u tvrtki {company}',
    peopleNoun: 'one:osoba|few:osobe|other:osoba',
    whatRead: 'Čitanje',
    whatReadWrite: 'Čitanje i pisanje',
    statusConnected: 'Povezano',
    statusOff: 'Isključeno',
    statusReconnect: 'Potrebno ponovno povezivanje',
    statusUnavailable: 'Nije dostupno',
    sheetTitle: 'Pristup: {name}',
    sheetTitleConnect: 'Tko može koristiti uslugu {name}?',
    appliesNext: 'Promjene vrijede od sljedećeg zahtjeva.',
    qWho: 'Tko ga može koristiti',
    optOnlyMe: 'Samo ja',
    optOnlyMeBody: 'Samo je vi možete koristiti. Nikad se ne prikazuje nikome drugome.',
    optEveryone: 'Svi u tvrtki {company}',
    optEveryoneBody:
      'Svatko u tvrtki {company} može je koristiti u svojim chatovima i aplikacijama.',
    optPeople: 'Određene osobe',
    addPeople: 'Dodajte osobe po imenu ili e-adresi…',
    ownerTag: 'Vlasnik',
    peopleEmpty: 'Dodajte barem jednu osobu ili odaberite Samo ja.',
    everyoneAdminOnly: 'Sa svima mogu dijeliti samo vlasnik ili administrator.',
    qWhat: 'Što Poneva može raditi',
    optRead: 'Čitanje',
    optReadBody: 'Poneva može pretraživati podatke. Nikad ništa ne mijenja.',
    optReadWrite: 'Čitanje i pisanje',
    optReadWriteBody: 'Poneva može i unositi promjene. Svaka promjena se bilježi.',
    reach: 'Do čega može doći',
    actionsNoun: 'one:radnja|few:radnje|other:radnji',
    reachCount: '{actions} · čitanje: {read} · pisanje: {write}',
    reachUnlabelled: 'Radnje koje usluga ne označava računaju se kao promjene.',
    reachDatabase:
      'Poneva može čitati sve što ova prijava u bazu podataka vidi. Za manje dijeljenja povežite se prijavom koja ima pristup samo onome što želite dijeliti.',
    turnOff: 'Isključi pristup',
    turnOffConfirm:
      'Isključiti {name}? Nitko je ne može koristiti dok se ponovno ne uključi. Ništa se ne briše.',
    remove: 'Ukloni vezu',
    removeConfirm:
      'Ukloniti {name}? Time se briše prijava koju je Poneva spremila. Chatovi i aplikacije koji su je koristili prestat će raditi. Podaci koji su već prikazani ili spremljeni u aplikacijama ostaju gdje jesu.',
    readOnlyNote: 'Ovo mogu promijeniti samo {owner} ili administrator.',
    saved: 'Pristup je ažuriran. Vrijedi od sljedećeg zahtjeva.',
    conflict: 'Netko drugi je ovo promijenio. Ovo je trenutačna postavka.',
    saveFailed: 'Spremanje nije uspjelo. Pokušajte ponovno.',
    yourAccess: 'Vaš pristup',
    ownWrite: 'Poneva može pisati u uslugu {name} umjesto vas. To ste dopustili: {date}.',
    ownWriteStop: 'Prestani pisati umjesto mene',
    ownWriteStopConfirm:
      'Zaustaviti Ponevino pisanje u uslugu {name} umjesto vas? Pisanje ponovno može uključiti samo vlasnik ili administrator.',
    ownWriteStopYes: 'Zaustavi pisanje',
    ownWriteKeep: 'Zadrži',
    ownRead:
      'Poneva može čitati uslugu {name} umjesto vas. Dok je postavljena na Čitanje, u njoj ništa ne mijenja.',
    audienceWrite: 'Pisanje je dopušteno svima koji mogu koristiti uslugu {name}.',
    onlyRead: 'Poneva može samo čitati uslugu {name}.',
    youSuffix: '(vi)',
    forEveryone: '{what}, za sve',
    activityTitle: 'Aktivnost',
    activityEmpty: 'Još nema aktivnosti. Svaki put kad Poneva koristi vezu, to se prikazuje ovdje.',
  },
  hu: {
    turnOn: 'Hozzáférés bekapcsolása',
    turnOnConfirm: 'Bekapcsolja a(z) {name} kapcsolatot a fenti hozzáféréssel?',
    failureUnknown: 'Az ok ismeretlen. Ellenőrizze a kapcsolat tesztelésével.',
    removeCredentialsConfirm:
      'Eltávolítja a(z) {name} kapcsolatot? A Poneva nem olvas tovább ezen a kapcsolaton keresztül, és törli a mentett hitelesítő adatokat. Az újracsatlakozáshoz ismét meg kell adnia őket. A beszélgetései és App-adatai megmaradnak.',
    fieldRequired: 'Adja meg: {field}.',
    fieldTooLong: '{field} túl hosszú.',
    fieldInvalid: 'Ellenőrizze: {field}.',
    testConnection: 'Kapcsolat tesztelése',
    allowWriteDone: 'Írás engedélyezve: {name}',
    agentWriteNeeded:
      'A(z) {name} Olvasás módra van állítva. Hogy ez az ügynök módosíthasson benne, állítsa Olvasás és írás módra a Kapcsolatokban.',
    agentWriteAsk:
      'A(z) {name} Olvasás módra van állítva, és ezt csak a tulajdonosa vagy egy rendszergazda módosíthatja. Kérje meg őket, hogy állítsák Olvasás és írás módra, hogy ez az ügynök módosíthasson benne.',
    openConnections: 'Kapcsolatok megnyitása',
    cardWriteNeeded:
      'A(z) {name} Olvasás módra van állítva, ezért ez addig nem futtatható, amíg a Kapcsolatokban nem állítják Olvasás és írás módra.',
    appWritesRow: 'Ez az alkalmazás módosításokat végez itt: {name}',
    agentWritesRow: 'Ez az ügynök módosításokat végez itt: {name}',
    appWritesBody:
      'A futtatások rákérdezés nélkül végeznek módosításokat. Ezt kikapcsolhatja a Hozzáférés szerkesztése részben.',
    appWritesAllow: 'Engedélyezés',
    cardEditAccess: 'Hozzáférés szerkesztése',
    cardViewAccess: 'Hozzáférés megtekintése',
    kindPipedream: 'Pipedream-alkalmazás',
    kindCustom: 'Egyéni kapcsolat',
    kindDatabase: 'Adatbázis',
    connectedBy: 'csatlakoztatta: {person}',
    whoOnlyYou: 'Csak Ön',
    whoEveryone: 'Mindenki itt: {company}',
    peopleNoun: 'one:fő|other:fő',
    whatRead: 'Olvasás',
    whatReadWrite: 'Olvasás és írás',
    statusConnected: 'Csatlakoztatva',
    statusOff: 'Kikapcsolva',
    statusReconnect: 'Újra kell csatlakoztatni',
    statusUnavailable: 'Nem érhető el',
    sheetTitle: 'Hozzáférés: {name}',
    sheetTitleConnect: 'Ki használhatja a következőt: {name}?',
    appliesNext: 'A módosítások a következő kéréstől érvényesek.',
    qWho: 'Ki használhatja',
    optOnlyMe: 'Csak én',
    optOnlyMeBody: 'Csak Ön használhatja. Soha senki más nem látja.',
    optEveryone: 'Mindenki itt: {company}',
    optEveryoneBody:
      'Bárki ebben a cégben ({company}) használhatja a csevegéseiben és az alkalmazásaiban.',
    optPeople: 'Adott személyek',
    addPeople: 'Személyek hozzáadása név vagy e-mail alapján…',
    ownerTag: 'Tulajdonos',
    peopleEmpty: 'Adjon hozzá legalább egy személyt, vagy válassza a Csak én lehetőséget.',
    everyoneAdminOnly: 'Mindenkivel csak tulajdonos vagy adminisztrátor oszthatja meg.',
    qWhat: 'Mit tehet a Poneva',
    optRead: 'Olvasás',
    optReadBody: 'A Poneva utánanézhet dolgoknak. Soha nem módosít semmit.',
    optReadWrite: 'Olvasás és írás',
    optReadWriteBody: 'A Poneva módosításokat is végezhet. Minden módosítás rögzül.',
    reach: 'Mihez fér hozzá',
    actionsNoun: 'one:művelet|other:művelet',
    reachCount: '{actions} · olvasás: {read} · írás: {write}',
    reachUnlabelled: 'A szolgáltatás által nem címkézett műveletek módosításnak számítanak.',
    reachDatabase:
      'A Poneva mindent el tud olvasni, amit ez az adatbázis-bejelentkezés lát. Ha kevesebbet szeretne megosztani, csatlakozzon olyan bejelentkezéssel, amely csak ahhoz fér hozzá, amit meg szeretne osztani.',
    turnOff: 'Hozzáférés kikapcsolása',
    turnOffConfirm:
      'Kikapcsolja ezt: {name}? Senki sem használhatja, amíg újra be nem kapcsolják. Semmi sem törlődik.',
    remove: 'Kapcsolat eltávolítása',
    removeConfirm:
      'Eltávolítja ezt: {name}? Ez törli a Poneva által mentett bejelentkezést. Az ezt használó csevegések és alkalmazások nem működnek tovább. A már megjelenített vagy alkalmazásokba mentett adatok megmaradnak.',
    readOnlyNote: 'Ezt csak {owner} vagy egy adminisztrátor módosíthatja.',
    saved: 'Hozzáférés frissítve. A következő kéréstől érvényes.',
    conflict: 'Valaki más módosította ezt. Ez a jelenlegi beállítás.',
    saveFailed: 'Nem sikerült menteni. Próbálja újra.',
    yourAccess: 'Az Ön hozzáférése',
    ownWrite: 'A Poneva az Ön nevében írhat ide: {name}. Ezt engedélyezte: {date}.',
    ownWriteStop: 'Ne írjon a nevemben',
    ownWriteStopConfirm:
      'Leállítja, hogy a Poneva az Ön nevében írjon ide: {name}? Az írást csak a tulajdonos vagy egy rendszergazda kapcsolhatja be újra.',
    ownWriteStopYes: 'Írás leállítása',
    ownWriteKeep: 'Megtartás',
    ownRead:
      'A Poneva az Ön nevében olvashatja ezt: {name}. Amíg Olvasás módra van állítva, semmit nem módosít benne.',
    audienceWrite: 'Az írás engedélyezett mindenkinek, aki használhatja a következőt: {name}.',
    onlyRead: 'A Poneva csak olvashatja ezt: {name}.',
    youSuffix: '(Ön)',
    forEveryone: '{what}, mindenkinek',
    activityTitle: 'Tevékenység',
    activityEmpty:
      'Még nincs tevékenység. Minden alkalommal, amikor a Poneva egy kapcsolatot használ, itt jelenik meg.',
  },
  it: {
    turnOn: 'Attiva accesso',
    turnOnConfirm: 'Attivare {name} con l’accesso mostrato sopra?',
    failureUnknown: 'Il motivo è sconosciuto. Prova la connessione per verificare.',
    removeCredentialsConfirm:
      'Rimuovere {name}? Poneva smette di leggere tramite questa connessione ed elimina le credenziali salvate. Per riconnetterti dovrai inserirle di nuovo. Le tue chat e i dati delle App restano.',
    fieldRequired: 'Inserisci {field}.',
    fieldTooLong: '{field} è troppo lungo.',
    fieldInvalid: 'Controlla {field}.',
    testConnection: 'Prova connessione',
    allowWriteDone: 'Scrittura consentita in {name}',
    agentWriteNeeded:
      '{name} è impostato su Lettura. Perché questo agente possa apportare modifiche, impostalo su Lettura e scrittura in Connessioni.',
    agentWriteAsk:
      '{name} è impostato su Lettura e solo il proprietario o un amministratore può cambiarlo. Chiedi loro di impostarlo su Lettura e scrittura perché questo agente possa apportare modifiche.',
    openConnections: 'Apri Connessioni',
    cardWriteNeeded:
      '{name} è impostato su Lettura, quindi questa azione non può essere eseguita finché non viene impostato su Lettura e scrittura in Connessioni.',
    appWritesRow: 'Questa App apporta modifiche in {name}',
    agentWritesRow: 'Questo agente apporta modifiche in {name}',
    appWritesBody:
      'Le esecuzioni apporteranno modifiche senza chiedere. Puoi disattivarlo in Modifica accesso.',
    appWritesAllow: 'Consenti',
    cardEditAccess: 'Modifica accesso',
    cardViewAccess: 'Visualizza accesso',
    kindPipedream: 'App Pipedream',
    kindCustom: 'Connessione personalizzata',
    kindDatabase: 'Database',
    connectedBy: 'collegata da {person}',
    whoOnlyYou: 'Solo tu',
    whoEveryone: 'Tutti in {company}',
    peopleNoun: 'one:persona|other:persone',
    whatRead: 'Lettura',
    whatReadWrite: 'Lettura e scrittura',
    statusConnected: 'Collegata',
    statusOff: 'Disattivata',
    statusReconnect: 'Da ricollegare',
    statusUnavailable: 'Non disponibile',
    sheetTitle: 'Accesso a {name}',
    sheetTitleConnect: 'Chi può usare {name}?',
    appliesNext: 'Le modifiche valgono dalla prossima richiesta.',
    qWho: 'Chi può usarlo',
    optOnlyMe: 'Solo io',
    optOnlyMeBody: 'Solo tu puoi usarla. Non compare mai a nessun altro.',
    optEveryone: 'Tutti in {company}',
    optEveryoneBody: 'Chiunque in {company} può usarla nelle proprie chat e App.',
    optPeople: 'Persone specifiche',
    addPeople: 'Aggiungi persone per nome o email…',
    ownerTag: 'Proprietario',
    peopleEmpty: 'Aggiungi almeno una persona oppure scegli Solo io.',
    everyoneAdminOnly: 'Solo un proprietario o un amministratore può condividere con tutti.',
    qWhat: 'Cosa può fare Poneva',
    optRead: 'Lettura',
    optReadBody: 'Poneva può cercare informazioni. Non modifica mai nulla.',
    optReadWrite: 'Lettura e scrittura',
    optReadWriteBody: 'Poneva può anche apportare modifiche. Ogni modifica viene registrata.',
    reach: 'Cosa può raggiungere',
    actionsNoun: 'one:azione|other:azioni',
    reachCount: '{actions} · {read} in lettura · {write} in scrittura',
    reachUnlabelled: 'Le azioni che il servizio non etichetta contano come modifiche.',
    reachDatabase:
      'Poneva può leggere tutto ciò che vede questo accesso al database. Per condividere meno, collegati con un accesso che vede solo ciò che vuoi condividere.',
    turnOff: 'Disattiva accesso',
    turnOffConfirm:
      'Disattivare {name}? Nessuno potrà usarla finché non verrà riattivata. Non viene eliminato nulla.',
    remove: 'Rimuovi connessione',
    removeConfirm:
      'Rimuovere {name}? Viene eliminato l’accesso salvato da Poneva. Le chat e le App che la usavano smettono di funzionare. I dati già mostrati o salvati nelle App restano dove sono.',
    readOnlyNote: 'Solo {owner} o un amministratore può modificarlo.',
    saved: 'Accesso aggiornato. Vale dalla prossima richiesta.',
    conflict: 'Qualcun altro l’ha modificato. Ecco l’impostazione attuale.',
    saveFailed: 'Impossibile salvare. Riprova.',
    yourAccess: 'Il tuo accesso',
    ownWrite: 'Poneva può scrivere in {name} per te. L’hai consentito il {date}.',
    ownWriteStop: 'Interrompi la scrittura per me',
    ownWriteStopConfirm:
      'Impedire a Poneva di scrivere in {name} per te? Solo il proprietario o un amministratore può riattivare la scrittura.',
    ownWriteStopYes: 'Interrompi la scrittura',
    ownWriteKeep: 'Mantieni',
    ownRead:
      'Poneva può leggere {name} per te. Finché è impostato su Lettura, non vi modifica nulla.',
    audienceWrite: 'La scrittura è consentita a tutti quelli che possono usare {name}.',
    onlyRead: 'Poneva può solo leggere {name}.',
    youSuffix: '(tu)',
    forEveryone: '{what}, per tutti',
    activityTitle: 'Attività',
    activityEmpty:
      'Ancora nessuna attività. Ogni volta che Poneva usa una connessione, compare qui.',
  },
  lt: {
    turnOn: 'Įjungti prieigą',
    turnOnConfirm: 'Įjungti {name} su aukščiau parodyta prieiga?',
    failureUnknown: 'Priežastis nežinoma. Patikrinkite ryšį.',
    removeCredentialsConfirm:
      'Pašalinti {name}? Poneva nustoja skaityti per šį ryšį ir ištrina išsaugotus prisijungimo duomenis. Norėdami vėl prisijungti, juos įvesite iš naujo. Jūsų pokalbiai ir App duomenys lieka.',
    fieldRequired: 'Įveskite {field}.',
    fieldTooLong: '{field} per ilgas.',
    fieldInvalid: 'Patikrinkite {field}.',
    testConnection: 'Tikrinti ryšį',
    allowWriteDone: 'Leista rašyti: {name}',
    agentWriteNeeded:
      '{name} nustatyta Skaitymas. Kad šis agentas galėtų atlikti pakeitimus, Jungtyse nustatykite Skaitymas ir rašymas.',
    agentWriteAsk:
      '„{name}“ nustatyta Skaitymas, ir tai pakeisti gali tik savininkas arba administratorius. Paprašykite jų nustatyti Skaitymas ir rašymas, kad šis agentas galėtų atlikti pakeitimus.',
    openConnections: 'Atidaryti Jungtis',
    cardWriteNeeded:
      '„{name}“ nustatyta Skaitymas, todėl to negalima atlikti, kol Jungtyse nebus nustatyta Skaitymas ir rašymas.',
    appWritesRow: 'Ši programėlė atlieka pakeitimus paslaugoje „{name}“',
    agentWritesRow: 'Šis agentas atlieka pakeitimus paslaugoje „{name}“',
    appWritesBody:
      'Vykdymai atliks pakeitimus neklausdami. Tai galite išjungti skiltyje „Redaguoti prieigą“.',
    appWritesAllow: 'Leisti',
    cardEditAccess: 'Redaguoti prieigą',
    cardViewAccess: 'Peržiūrėti prieigą',
    kindPipedream: 'Pipedream programėlė',
    kindCustom: 'Pasirinktinė jungtis',
    kindDatabase: 'Duomenų bazė',
    connectedBy: 'prijungė: {person}',
    whoOnlyYou: 'Tik jūs',
    whoEveryone: 'Visi įmonėje „{company}“',
    peopleNoun: 'one:žmogus|few:žmonės|many:žmogaus|other:žmonių',
    whatRead: 'Skaitymas',
    whatReadWrite: 'Skaitymas ir rašymas',
    statusConnected: 'Prijungta',
    statusOff: 'Išjungta',
    statusReconnect: 'Reikia prijungti iš naujo',
    statusUnavailable: 'Nepasiekiama',
    sheetTitle: 'Prieiga: {name}',
    sheetTitleConnect: 'Kas gali naudotis: {name}?',
    appliesNext: 'Pakeitimai taikomi nuo kitos užklausos.',
    qWho: 'Kas gali jį naudoti',
    optOnlyMe: 'Tik aš',
    optOnlyMeBody: 'Naudotis galite tik jūs. Kitiems ji niekada nerodoma.',
    optEveryone: 'Visi įmonėje „{company}“',
    optEveryoneBody:
      'Bet kas įmonėje „{company}“ gali ja naudotis savo pokalbiuose ir programėlėse.',
    optPeople: 'Konkretūs žmonės',
    addPeople: 'Pridėkite žmonių pagal vardą arba el. paštą…',
    ownerTag: 'Savininkas',
    peopleEmpty: 'Pridėkite bent vieną žmogų arba pasirinkite „Tik aš“.',
    everyoneAdminOnly: 'Su visais bendrinti gali tik savininkas arba administratorius.',
    qWhat: 'Ką Poneva gali daryti',
    optRead: 'Skaitymas',
    optReadBody: 'Poneva gali ieškoti informacijos. Ji niekada nieko nekeičia.',
    optReadWrite: 'Skaitymas ir rašymas',
    optReadWriteBody: 'Poneva taip pat gali atlikti pakeitimus. Kiekvienas pakeitimas įrašomas.',
    reach: 'Ką ji gali pasiekti',
    actionsNoun: 'one:veiksmas|few:veiksmai|many:veiksmo|other:veiksmų',
    reachCount: '{actions} · skaitymas: {read} · rašymas: {write}',
    reachUnlabelled: 'Veiksmai, kurių paslauga nepažymi, laikomi pakeitimais.',
    reachDatabase:
      'Poneva gali skaityti viską, ką mato šis duomenų bazės prisijungimas. Kad bendrintumėte mažiau, prisijunkite su prisijungimu, kuris turi prieigą tik prie to, ką norite bendrinti.',
    turnOff: 'Išjungti prieigą',
    turnOffConfirm:
      'Išjungti: {name}? Niekas negalės ja naudotis, kol ji nebus vėl įjungta. Niekas neištrinama.',
    remove: 'Pašalinti jungtį',
    removeConfirm:
      'Pašalinti: {name}? Bus ištrintas Poneva išsaugotas prisijungimas. Ja naudoję pokalbiai ir programėlės nustos veikti. Jau parodyti ar programėlėse išsaugoti duomenys liks ten, kur yra.',
    readOnlyNote: 'Tai pakeisti gali tik {owner} arba administratorius.',
    saved: 'Prieiga atnaujinta. Taikoma nuo kitos užklausos.',
    conflict: 'Kažkas kitas tai pakeitė. Štai dabartinis nustatymas.',
    saveFailed: 'Nepavyko išsaugoti. Bandykite dar kartą.',
    yourAccess: 'Jūsų prieiga',
    ownWrite: 'Poneva gali rašyti į paslaugą „{name}“ jūsų vardu. Leidote tai: {date}.',
    ownWriteStop: 'Nebeleisti rašyti mano vardu',
    ownWriteStopConfirm:
      'Neleisti Poneva rašyti į paslaugą „{name}“ jūsų vardu? Rašymą vėl įjungti gali tik savininkas arba administratorius.',
    ownWriteStopYes: 'Nebeleisti rašyti',
    ownWriteKeep: 'Palikti',
    ownRead:
      'Poneva gali skaityti paslaugą „{name}“ jūsų vardu. Kol nustatyta Skaitymas, Poneva nieko joje nekeičia.',
    audienceWrite: 'Rašyti leidžiama visiems, kurie gali naudotis paslauga „{name}“.',
    onlyRead: 'Poneva gali tik skaityti paslaugą „{name}“.',
    youSuffix: '(jūs)',
    forEveryone: '{what}, visiems',
    activityTitle: 'Veikla',
    activityEmpty: 'Veiklos dar nėra. Kiekvieną kartą, kai Poneva naudoja jungtį, tai rodoma čia.',
  },
  lv: {
    turnOn: 'Ieslēgt piekļuvi',
    turnOnConfirm: 'Vai ieslēgt {name} ar iepriekš parādīto piekļuvi?',
    failureUnknown: 'Iemesls nav zināms. Pārbaudei testējiet savienojumu.',
    removeCredentialsConfirm:
      'Vai noņemt {name}? Poneva pārtrauc lasīt caur šo savienojumu un dzēš saglabātos piekļuves datus. Lai savienotu atkārtoti, jums tie būs jāievada vēlreiz. Jūsu sarunas un App dati paliek.',
    fieldRequired: 'Ievadiet {field}.',
    fieldTooLong: '{field} ir pārāk garš.',
    fieldInvalid: 'Pārbaudiet {field}.',
    testConnection: 'Testēt savienojumu',
    allowWriteDone: 'Rakstīšana atļauta: {name}',
    agentWriteNeeded:
      '{name} ir iestatīts uz Lasīšana. Lai šis aģents varētu veikt izmaiņas, iestatiet to uz Lasīšana un rakstīšana sadaļā Savienojumi.',
    agentWriteAsk:
      '{name} ir iestatīts uz Lasīšana, un to var mainīt tikai īpašnieks vai administrators. Palūdziet viņiem iestatīt Lasīšana un rakstīšana, lai šis aģents varētu veikt izmaiņas.',
    openConnections: 'Atvērt Savienojumus',
    cardWriteNeeded:
      '{name} ir iestatīts uz Lasīšana, tāpēc to nevar izpildīt, kamēr sadaļā Savienojumi tas nav iestatīts uz Lasīšana un rakstīšana.',
    appWritesRow: 'Šī lietotne veic izmaiņas pakalpojumā “{name}”',
    agentWritesRow: 'Šis aģents veic izmaiņas pakalpojumā “{name}”',
    appWritesBody:
      'Palaišanas reizēs izmaiņas tiks veiktas bez jautāšanas. To varat izslēgt sadaļā “Rediģēt piekļuvi”.',
    appWritesAllow: 'Atļaut',
    cardEditAccess: 'Rediģēt piekļuvi',
    cardViewAccess: 'Skatīt piekļuvi',
    kindPipedream: 'Pipedream lietotne',
    kindCustom: 'Pielāgots savienojums',
    kindDatabase: 'Datubāze',
    connectedBy: 'pievienoja: {person}',
    whoOnlyYou: 'Tikai jūs',
    whoEveryone: 'Visi uzņēmumā “{company}”',
    peopleNoun: 'zero:cilvēku|one:cilvēks|other:cilvēki',
    whatRead: 'Lasīšana',
    whatReadWrite: 'Lasīšana un rakstīšana',
    statusConnected: 'Pievienots',
    statusOff: 'Izslēgts',
    statusReconnect: 'Jāpievieno atkārtoti',
    statusUnavailable: 'Nav pieejams',
    sheetTitle: 'Piekļuve: {name}',
    sheetTitleConnect: 'Kas var izmantot: {name}?',
    appliesNext: 'Izmaiņas stājas spēkā ar nākamo pieprasījumu.',
    qWho: 'Kas to var izmantot',
    optOnlyMe: 'Tikai es',
    optOnlyMeBody: 'To varat izmantot tikai jūs. Citiem tas nekad netiek rādīts.',
    optEveryone: 'Visi uzņēmumā “{company}”',
    optEveryoneBody: 'Ikviens uzņēmumā “{company}” to var izmantot savās tērzēšanās un lietotnēs.',
    optPeople: 'Konkrēti cilvēki',
    addPeople: 'Pievienojiet cilvēkus pēc vārda vai e-pasta…',
    ownerTag: 'Īpašnieks',
    peopleEmpty: 'Pievienojiet vismaz vienu cilvēku vai izvēlieties “Tikai es”.',
    everyoneAdminOnly: 'Ar visiem kopīgot var tikai īpašnieks vai administrators.',
    qWhat: 'Ko Poneva var darīt',
    optRead: 'Lasīšana',
    optReadBody: 'Poneva var meklēt informāciju. Tā nekad neko nemaina.',
    optReadWrite: 'Lasīšana un rakstīšana',
    optReadWriteBody: 'Poneva var arī veikt izmaiņas. Katra izmaiņa tiek reģistrēta.',
    reach: 'Ko tā var sasniegt',
    actionsNoun: 'zero:darbību|one:darbība|other:darbības',
    reachCount: '{actions} · lasīšana: {read} · rakstīšana: {write}',
    reachUnlabelled: 'Darbības, ko pakalpojums neatzīmē, tiek uzskatītas par izmaiņām.',
    reachDatabase:
      'Poneva var lasīt visu, ko redz šis datubāzes pieteikšanās konts. Lai kopīgotu mazāk, pievienojieties ar kontu, kam ir piekļuve tikai tam, ko vēlaties kopīgot.',
    turnOff: 'Izslēgt piekļuvi',
    turnOffConfirm:
      'Izslēgt: {name}? Neviens to nevarēs izmantot, līdz tas atkal tiks ieslēgts. Nekas netiek dzēsts.',
    remove: 'Noņemt savienojumu',
    removeConfirm:
      'Noņemt: {name}? Tiks dzēsta Poneva saglabātā pieteikšanās. Tērzēšanas un lietotnes, kas to izmantoja, pārstās darboties. Jau parādītie vai lietotnēs saglabātie dati paliks, kur ir.',
    readOnlyNote: 'To var mainīt tikai {owner} vai administrators.',
    saved: 'Piekļuve atjaunināta. Stājas spēkā ar nākamo pieprasījumu.',
    conflict: 'Kāds cits to mainīja. Šeit ir pašreizējais iestatījums.',
    saveFailed: 'Neizdevās saglabāt. Mēģiniet vēlreiz.',
    yourAccess: 'Jūsu piekļuve',
    ownWrite: 'Poneva var rakstīt pakalpojumā “{name}” jūsu vārdā. Jūs to atļāvāt: {date}.',
    ownWriteStop: 'Pārtraukt rakstīšanu manā vārdā',
    ownWriteStopConfirm:
      'Neļaut Poneva rakstīt pakalpojumā “{name}” jūsu vārdā? Rakstīšanu atkal ieslēgt var tikai īpašnieks vai administrators.',
    ownWriteStopYes: 'Pārtraukt rakstīšanu',
    ownWriteKeep: 'Paturēt',
    ownRead:
      'Poneva var lasīt pakalpojumu “{name}” jūsu vārdā. Kamēr tas ir iestatīts uz Lasīšana, tā tajā neko nemaina.',
    audienceWrite: 'Rakstīšana ir atļauta visiem, kas var izmantot pakalpojumu “{name}”.',
    onlyRead: 'Poneva var tikai lasīt pakalpojumu “{name}”.',
    youSuffix: '(jūs)',
    forEveryone: '{what}, visiem',
    activityTitle: 'Darbība',
    activityEmpty:
      'Vēl nav darbību. Katru reizi, kad Poneva izmanto savienojumu, tas tiek parādīts šeit.',
  },
  mt: {
    turnOn: 'Ixgħel l-aċċess',
    turnOnConfirm: 'Tixgħel {name} bl-aċċess muri hawn fuq?',
    failureUnknown: 'Ir-raġuni mhix magħrufa. Ittestja l-konnessjoni biex tiċċekkja.',
    removeCredentialsConfirm:
      'Tneħħi {name}? Poneva tieqaf taqra permezz ta’ din il-konnessjoni u tħassar il-kredenzjali maħżuna. Biex terġa’ tikkonnettja, se jkollok iddaħħalhom mill-ġdid. Iċ-chats u d-data tal-Apps tiegħek jibqgħu.',
    fieldRequired: 'Daħħal {field}.',
    fieldTooLong: '{field} huwa twil wisq.',
    fieldInvalid: 'Iċċekkja {field}.',
    testConnection: 'Ittestja l-konnessjoni',
    allowWriteDone: 'Il-kitba permessa f’{name}',
    agentWriteNeeded:
      '{name} huwa ssettjat fuq Qari. Biex dan l-aġent ikun jista’ jagħmel bidliet, issettjah fuq Qari u kitba f’Konnessjonijiet.',
    agentWriteAsk:
      '{name} huwa ssettjat fuq Qari, u dan jista’ jibdlu biss is-sid jew amministratur. Itlobhom jissettjawh fuq Qari u kitba biex dan l-aġent ikun jista’ jagħmel bidliet.',
    openConnections: 'Iftaħ Konnessjonijiet',
    cardWriteNeeded:
      '{name} huwa ssettjat fuq Qari, għalhekk dan ma jistax jitħaddem sakemm ma jiġix issettjat fuq Qari u kitba f’Konnessjonijiet.',
    appWritesRow: 'Din l-app tagħmel bidliet f’{name}',
    agentWritesRow: 'Dan l-aġent jagħmel bidliet f’{name}',
    appWritesBody:
      'It-tħaddim se jagħmel bidliet mingħajr ma jistaqsi. Tista’ titfi dan f’Editja l-aċċess.',
    appWritesAllow: 'Ħalli',
    cardEditAccess: 'Editja l-aċċess',
    cardViewAccess: 'Ara l-aċċess',
    kindPipedream: 'App Pipedream',
    kindCustom: 'Konnessjoni personalizzata',
    kindDatabase: 'Database',
    connectedBy: 'konnessa minn {person}',
    whoOnlyYou: 'Int biss',
    whoEveryone: 'Kulħadd f’{company}',
    peopleNoun: 'one:persuna|two:persuni|few:persuni|many:persuna|other:persuna',
    whatRead: 'Qari',
    whatReadWrite: 'Qari u kitba',
    statusConnected: 'Konness',
    statusOff: 'Mitfi',
    statusReconnect: 'Jeħtieġ konnessjoni mill-ġdid',
    statusUnavailable: 'Mhux disponibbli',
    sheetTitle: 'Aċċess għal {name}',
    sheetTitleConnect: 'Min jista’ juża {name}?',
    appliesNext: 'Il-bidliet japplikaw għat-talba li jmiss.',
    qWho: 'Min jista’ jużah',
    optOnlyMe: 'Jien biss',
    optOnlyMeBody: 'Int biss tista’ tużah. Qatt ma jidher lil ħaddieħor.',
    optEveryone: 'Kulħadd f’{company}',
    optEveryoneBody: 'Kulħadd f’{company} jista’ jużah fiċ-chats u fl-apps tiegħu.',
    optPeople: 'Persuni speċifiċi',
    addPeople: 'Żid persuni bl-isem jew bl-email…',
    ownerTag: 'Sid',
    peopleEmpty: 'Żid mill-inqas persuna waħda, jew agħżel Jien biss.',
    everyoneAdminOnly: 'Sid jew amministratur biss jista’ jaqsam ma’ kulħadd.',
    qWhat: 'X’jista’ jagħmel Poneva',
    optRead: 'Qari',
    optReadBody: 'Poneva jista’ jfittex l-informazzjoni. Qatt ma jibdel xejn.',
    optReadWrite: 'Qari u kitba',
    optReadWriteBody: 'Poneva jista’ wkoll jagħmel bidliet. Kull bidla tiġi rreġistrata.',
    reach: 'X’jista’ jilħaq',
    actionsNoun: 'one:azzjoni|two:azzjonijiet|few:azzjonijiet|many:azzjoni|other:azzjoni',
    reachCount: '{actions} · qari: {read} · kitba: {write}',
    reachUnlabelled: 'L-azzjonijiet li s-servizz ma jittikkettjax jgħoddu bħala bidliet.',
    reachDatabase:
      'Poneva jista’ jaqra kull ma jista’ jara dan il-login tad-database. Biex taqsam inqas, ikkonnettja b’login li għandu aċċess biss għal dak li trid taqsam.',
    turnOff: 'Itfi l-aċċess',
    turnOffConfirm:
      'Titfi {name}? Ħadd ma jista’ jużah sakemm jerġa’ jinxtegħel. Xejn ma jitħassar.',
    remove: 'Neħħi l-konnessjoni',
    removeConfirm:
      'Tneħħi {name}? Dan iħassar il-login li ssejvja Poneva. Iċ-chats u l-apps li użawh jieqfu jaħdmu. Id-dejta diġà murija jew issejvjata fl-apps tibqa’ fejn hi.',
    readOnlyNote: '{owner} jew amministratur biss jista’ jibdel dan.',
    saved: 'L-aċċess ġie aġġornat. Japplika għat-talba li jmiss.',
    conflict: 'Xi ħadd ieħor biddel dan. Hawn hu l-issettjar attwali.',
    saveFailed: 'Ma setax jiġi ssejvjat. Erġa’ pprova.',
    yourAccess: 'L-aċċess tiegħek',
    ownWrite: 'Poneva jista’ jikteb f’{name} għalik. Ħallejt dan fil-{date}.',
    ownWriteStop: 'Waqqaf il-kitba għalija',
    ownWriteStopConfirm:
      'Twaqqaf lil Poneva milli jikteb f’{name} għalik? Is-sid jew amministratur biss jista’ jerġa’ jixgħel il-kitba.',
    ownWriteStopYes: 'Waqqaf il-kitba',
    ownWriteKeep: 'Żomm',
    ownRead:
      'Poneva jista’ jaqra {name} għalik. Ma jibdel xejn hemm sakemm ikun issettjat fuq Qari.',
    audienceWrite: 'Il-kitba hija permessa għal kull min jista’ juża {name}.',
    onlyRead: 'Poneva jista’ jaqra {name} biss.',
    youSuffix: '(int)',
    forEveryone: '{what}, għal kulħadd',
    activityTitle: 'Attività',
    activityEmpty: 'Għad m’hemmx attività. Kull darba li Poneva juża konnessjoni, tidher hawn.',
  },
  nl: {
    turnOn: 'Toegang inschakelen',
    turnOnConfirm: '{name} inschakelen met de hierboven getoonde toegang?',
    failureUnknown: 'De reden is onbekend. Test de verbinding om dit te controleren.',
    removeCredentialsConfirm:
      '{name} verwijderen? Poneva leest niet meer via deze verbinding en verwijdert de opgeslagen inloggegevens. Om opnieuw te verbinden, voer je ze opnieuw in. Je chats en App-gegevens blijven bestaan.',
    fieldRequired: 'Vul {field} in.',
    fieldTooLong: '{field} is te lang.',
    fieldInvalid: 'Controleer {field}.',
    testConnection: 'Verbinding testen',
    allowWriteDone: 'Schrijven toegestaan in {name}',
    agentWriteNeeded:
      '{name} staat op Lezen. Zet het op Lezen en schrijven in Verbindingen zodat deze agent er wijzigingen kan maken.',
    agentWriteAsk:
      '{name} staat op Lezen en alleen de eigenaar of een beheerder kan dat wijzigen. Vraag hen het op Lezen en schrijven te zetten zodat deze agent er wijzigingen kan maken.',
    openConnections: 'Verbindingen openen',
    cardWriteNeeded:
      '{name} staat op Lezen, dus dit kan pas worden uitgevoerd als het in Verbindingen op Lezen en schrijven staat.',
    appWritesRow: 'Deze app brengt wijzigingen aan in {name}',
    agentWritesRow: 'Deze agent brengt wijzigingen aan in {name}',
    appWritesBody:
      'Uitvoeringen brengen wijzigingen aan zonder te vragen. Je kunt dit uitzetten via Toegang bewerken.',
    appWritesAllow: 'Toestaan',
    cardEditAccess: 'Toegang bewerken',
    cardViewAccess: 'Toegang bekijken',
    kindPipedream: 'Pipedream-app',
    kindCustom: 'Eigen verbinding',
    kindDatabase: 'Database',
    connectedBy: 'verbonden door {person}',
    whoOnlyYou: 'Alleen jij',
    whoEveryone: 'Iedereen bij {company}',
    peopleNoun: 'one:persoon|other:personen',
    whatRead: 'Lezen',
    whatReadWrite: 'Lezen en schrijven',
    statusConnected: 'Verbonden',
    statusOff: 'Uitgeschakeld',
    statusReconnect: 'Opnieuw verbinden nodig',
    statusUnavailable: 'Niet beschikbaar',
    sheetTitle: 'Toegang tot {name}',
    sheetTitleConnect: 'Wie kan {name} gebruiken?',
    appliesNext: 'Wijzigingen gelden vanaf het volgende verzoek.',
    qWho: 'Wie het kan gebruiken',
    optOnlyMe: 'Alleen ik',
    optOnlyMeBody: 'Alleen jij kunt hem gebruiken. Hij is nooit zichtbaar voor anderen.',
    optEveryone: 'Iedereen bij {company}',
    optEveryoneBody: 'Iedereen bij {company} kan hem gebruiken in eigen chats en apps.',
    optPeople: 'Specifieke personen',
    addPeople: 'Voeg personen toe op naam of e-mailadres…',
    ownerTag: 'Eigenaar',
    peopleEmpty: 'Voeg minstens één persoon toe, of kies Alleen ik.',
    everyoneAdminOnly: 'Alleen een eigenaar of beheerder kan met iedereen delen.',
    qWhat: 'Wat Poneva kan doen',
    optRead: 'Lezen',
    optReadBody: 'Poneva kan dingen opzoeken. Er wordt nooit iets gewijzigd.',
    optReadWrite: 'Lezen en schrijven',
    optReadWriteBody: 'Poneva kan ook wijzigingen aanbrengen. Elke wijziging wordt vastgelegd.',
    reach: 'Wat hij kan bereiken',
    actionsNoun: 'one:actie|other:acties',
    reachCount: '{actions} · {read} lezen · {write} schrijven',
    reachUnlabelled: 'Acties die de dienst niet labelt, tellen als wijzigingen.',
    reachDatabase:
      'Poneva kan alles lezen wat deze databaselogin kan zien. Wil je minder delen, verbind dan met een login die alleen toegang heeft tot wat je wilt delen.',
    turnOff: 'Toegang uitschakelen',
    turnOffConfirm:
      '{name} uitschakelen? Niemand kan hem gebruiken tot hij weer wordt ingeschakeld. Er wordt niets verwijderd.',
    remove: 'Verbinding verwijderen',
    removeConfirm:
      '{name} verwijderen? Hiermee wordt de door Poneva opgeslagen aanmelding verwijderd. Chats en apps die hem gebruikten, werken niet meer. Gegevens die al zijn getoond of in apps zijn opgeslagen, blijven waar ze zijn.',
    readOnlyNote: 'Alleen {owner} of een beheerder kan dit wijzigen.',
    saved: 'Toegang bijgewerkt. Geldt vanaf het volgende verzoek.',
    conflict: 'Iemand anders heeft dit gewijzigd. Dit is de huidige instelling.',
    saveFailed: 'Opslaan is mislukt. Probeer het opnieuw.',
    yourAccess: 'Jouw toegang',
    ownWrite: 'Poneva kan voor jou naar {name} schrijven. Je hebt dit toegestaan op {date}.',
    ownWriteStop: 'Stoppen met schrijven voor mij',
    ownWriteStopConfirm:
      'Poneva laten stoppen met voor jou naar {name} schrijven? Alleen de eigenaar of een beheerder kan schrijven weer aanzetten.',
    ownWriteStopYes: 'Stoppen met schrijven',
    ownWriteKeep: 'Behouden',
    ownRead:
      'Poneva kan {name} voor jou lezen. Zolang het op Lezen staat, wijzigt Poneva daar niets.',
    audienceWrite: 'Schrijven is toegestaan voor iedereen die {name} kan gebruiken.',
    onlyRead: 'Poneva kan {name} alleen lezen.',
    youSuffix: '(jij)',
    forEveryone: '{what}, voor iedereen',
    activityTitle: 'Activiteit',
    activityEmpty:
      'Nog geen activiteit. Elke keer dat Poneva een verbinding gebruikt, verschijnt dat hier.',
  },
  pl: {
    turnOn: 'Włącz dostęp',
    turnOnConfirm: 'Włączyć {name} z dostępem pokazanym powyżej?',
    failureUnknown: 'Przyczyna jest nieznana. Przetestuj połączenie, aby sprawdzić.',
    removeCredentialsConfirm:
      'Usunąć {name}? Poneva przestanie czytać przez to połączenie i usunie zapisane dane logowania. Aby połączyć ponownie, wprowadzisz je jeszcze raz. Twoje czaty i dane App pozostaną.',
    fieldRequired: 'Wpisz {field}.',
    fieldTooLong: '{field} jest zbyt długie.',
    fieldInvalid: 'Sprawdź {field}.',
    testConnection: 'Testuj połączenie',
    allowWriteDone: 'Zapisywanie dozwolone: {name}',
    agentWriteNeeded:
      '{name} ma ustawienie Odczyt. Aby ten agent mógł wprowadzać zmiany, ustaw w Połączeniach Odczyt i zapis.',
    agentWriteAsk:
      '{name} ma ustawienie Odczyt i zmienić to może tylko właściciel lub administrator. Poproś ich o ustawienie Odczyt i zapis, aby ten agent mógł wprowadzać zmiany.',
    openConnections: 'Otwórz Połączenia',
    cardWriteNeeded:
      '{name} ma ustawienie Odczyt, więc nie można tego wykonać, dopóki w Połączeniach nie zostanie ustawione Odczyt i zapis.',
    appWritesRow: 'Ta aplikacja wprowadza zmiany w usłudze {name}',
    agentWritesRow: 'Ten agent wprowadza zmiany w usłudze {name}',
    appWritesBody:
      'Uruchomienia będą wprowadzać zmiany bez pytania. Możesz to wyłączyć w sekcji Edytuj dostęp.',
    appWritesAllow: 'Zezwól',
    cardEditAccess: 'Edytuj dostęp',
    cardViewAccess: 'Pokaż dostęp',
    kindPipedream: 'Aplikacja Pipedream',
    kindCustom: 'Własne połączenie',
    kindDatabase: 'Baza danych',
    connectedBy: 'połączone przez: {person}',
    whoOnlyYou: 'Tylko ty',
    whoEveryone: 'Wszyscy w firmie {company}',
    peopleNoun: 'one:osoba|few:osoby|many:osób|other:osoby',
    whatRead: 'Odczyt',
    whatReadWrite: 'Odczyt i zapis',
    statusConnected: 'Połączono',
    statusOff: 'Wyłączone',
    statusReconnect: 'Wymaga ponownego połączenia',
    statusUnavailable: 'Niedostępne',
    sheetTitle: 'Dostęp: {name}',
    sheetTitleConnect: 'Kto może korzystać z usługi {name}?',
    appliesNext: 'Zmiany obowiązują od następnego żądania.',
    qWho: 'Kto może go używać',
    optOnlyMe: 'Tylko ja',
    optOnlyMeBody: 'Tylko ty możesz z niego korzystać. Nigdy nie jest widoczne dla innych.',
    optEveryone: 'Wszyscy w firmie {company}',
    optEveryoneBody:
      'Każdy w firmie {company} może z niego korzystać w swoich czatach i aplikacjach.',
    optPeople: 'Wybrane osoby',
    addPeople: 'Dodaj osoby według imienia i nazwiska lub adresu e-mail…',
    ownerTag: 'Właściciel',
    peopleEmpty: 'Dodaj co najmniej jedną osobę albo wybierz Tylko ja.',
    everyoneAdminOnly: 'Tylko właściciel lub administrator może udostępnić wszystkim.',
    qWhat: 'Co może robić Poneva',
    optRead: 'Odczyt',
    optReadBody: 'Poneva może wyszukiwać informacje. Nigdy niczego nie zmienia.',
    optReadWrite: 'Odczyt i zapis',
    optReadWriteBody: 'Poneva może też wprowadzać zmiany. Każda zmiana jest zapisywana.',
    reach: 'Do czego ma dostęp',
    actionsNoun: 'one:działanie|few:działania|many:działań|other:działania',
    reachCount: '{actions} · odczyt: {read} · zapis: {write}',
    reachUnlabelled: 'Działania, których usługa nie oznacza, liczą się jako zmiany.',
    reachDatabase:
      'Poneva może odczytać wszystko, co widzi ten login do bazy danych. Aby udostępnić mniej, połącz się za pomocą loginu, który ma dostęp tylko do tego, co chcesz udostępnić.',
    turnOff: 'Wyłącz dostęp',
    turnOffConfirm:
      'Wyłączyć: {name}? Nikt nie będzie mógł z tego korzystać, dopóki nie zostanie ponownie włączone. Nic nie zostanie usunięte.',
    remove: 'Usuń połączenie',
    removeConfirm:
      'Usunąć: {name}? Spowoduje to usunięcie danych logowania zapisanych przez Ponevę. Czaty i aplikacje, które z tego korzystały, przestaną działać. Dane już wyświetlone lub zapisane w aplikacjach pozostaną na miejscu.',
    readOnlyNote: 'Tylko {owner} lub administrator może to zmienić.',
    saved: 'Dostęp zaktualizowany. Obowiązuje od następnego żądania.',
    conflict: 'Ktoś inny to zmienił. Oto bieżące ustawienie.',
    saveFailed: 'Nie udało się zapisać. Spróbuj ponownie.',
    yourAccess: 'Twój dostęp',
    ownWrite: 'Poneva może zapisywać w usłudze {name} w twoim imieniu. Zezwolono: {date}.',
    ownWriteStop: 'Wyłącz zapisywanie w moim imieniu',
    ownWriteStopConfirm:
      'Wyłączyć zapisywanie przez Ponevę w usłudze {name} w twoim imieniu? Ponownie włączyć zapis może tylko właściciel lub administrator.',
    ownWriteStopYes: 'Wyłącz zapisywanie',
    ownWriteKeep: 'Zachowaj',
    ownRead:
      'Poneva może odczytywać usługę {name} w twoim imieniu. Dopóki ma ustawienie Odczyt, niczego w niej nie zmienia.',
    audienceWrite:
      'Zapisywanie jest dozwolone dla wszystkich, którzy mogą korzystać z usługi {name}.',
    onlyRead: 'Poneva może tylko odczytywać usługę {name}.',
    youSuffix: '(ty)',
    forEveryone: '{what}, dla wszystkich',
    activityTitle: 'Aktywność',
    activityEmpty:
      'Brak aktywności. Za każdym razem, gdy Poneva korzysta z połączenia, pojawi się to tutaj.',
  },
  pt: {
    turnOn: 'Ativar acesso',
    turnOnConfirm: 'Ativar {name} com o acesso indicado acima?',
    failureUnknown: 'O motivo é desconhecido. Teste a ligação para verificar.',
    removeCredentialsConfirm:
      'Remover {name}? O Poneva deixa de ler através desta ligação e elimina as credenciais guardadas. Para voltar a ligar, terá de as introduzir novamente. Os seus chats e dados das Apps permanecem.',
    fieldRequired: 'Introduza {field}.',
    fieldTooLong: '{field} é demasiado longo.',
    fieldInvalid: 'Verifique {field}.',
    testConnection: 'Testar ligação',
    allowWriteDone: 'Escrita permitida em {name}',
    agentWriteNeeded:
      '{name} está definido como Leitura. Para que este agente possa fazer alterações, defina-o como Leitura e escrita em Ligações.',
    agentWriteAsk:
      '{name} está definido como Leitura e só o proprietário ou um administrador o pode alterar. Peça-lhes que o definam como Leitura e escrita para que este agente possa fazer alterações.',
    openConnections: 'Abrir Ligações',
    cardWriteNeeded:
      '{name} está definido como Leitura, por isso isto não pode ser executado até ser definido como Leitura e escrita em Ligações.',
    appWritesRow: 'Esta App faz alterações em {name}',
    agentWritesRow: 'Este agente faz alterações em {name}',
    appWritesBody:
      'As execuções farão alterações sem perguntar. Pode desativar isto em Editar acesso.',
    appWritesAllow: 'Permitir',
    cardEditAccess: 'Editar acesso',
    cardViewAccess: 'Ver acesso',
    kindPipedream: 'App Pipedream',
    kindCustom: 'Ligação personalizada',
    kindDatabase: 'Base de dados',
    connectedBy: 'ligada por {person}',
    whoOnlyYou: 'Só para si',
    whoEveryone: 'Todos em {company}',
    peopleNoun: 'one:pessoa|other:pessoas',
    whatRead: 'Leitura',
    whatReadWrite: 'Leitura e escrita',
    statusConnected: 'Ligada',
    statusOff: 'Desativada',
    statusReconnect: 'Precisa de nova ligação',
    statusUnavailable: 'Indisponível',
    sheetTitle: 'Acesso a {name}',
    sheetTitleConnect: 'Quem pode usar {name}?',
    appliesNext: 'As alterações aplicam-se ao próximo pedido.',
    qWho: 'Quem a pode usar',
    optOnlyMe: 'Só eu',
    optOnlyMeBody: 'Só você a pode usar. Nunca aparece a mais ninguém.',
    optEveryone: 'Todos em {company}',
    optEveryoneBody: 'Qualquer pessoa em {company} a pode usar nos seus chats e Apps.',
    optPeople: 'Pessoas específicas',
    addPeople: 'Adicione pessoas por nome ou email…',
    ownerTag: 'Proprietário',
    peopleEmpty: 'Adicione pelo menos uma pessoa ou escolha Só eu.',
    everyoneAdminOnly: 'Só um proprietário ou administrador pode partilhar com todos.',
    qWhat: 'O que o Poneva pode fazer',
    optRead: 'Leitura',
    optReadBody: 'O Poneva pode consultar informações. Nunca altera nada.',
    optReadWrite: 'Leitura e escrita',
    optReadWriteBody: 'O Poneva também pode fazer alterações. Cada alteração fica registada.',
    reach: 'O que pode alcançar',
    actionsNoun: 'one:ação|other:ações',
    reachCount: '{actions} · {read} de leitura · {write} de escrita',
    reachUnlabelled: 'As ações que o serviço não identifica contam como alterações.',
    reachDatabase:
      'O Poneva pode ler tudo o que este início de sessão da base de dados consegue ver. Para partilhar menos, ligue com um início de sessão que só tenha acesso ao que quer partilhar.',
    turnOff: 'Desativar acesso',
    turnOffConfirm: 'Desativar {name}? Ninguém a pode usar até ser reativada. Nada é eliminado.',
    remove: 'Remover ligação',
    removeConfirm:
      'Remover {name}? Isto elimina o início de sessão que o Poneva guardou. Os chats e Apps que a usavam deixam de funcionar. Os dados já mostrados ou guardados em Apps ficam onde estão.',
    readOnlyNote: 'Só {owner} ou um administrador pode alterar isto.',
    saved: 'Acesso atualizado. Aplica-se ao próximo pedido.',
    conflict: 'Outra pessoa alterou isto. Esta é a definição atual.',
    saveFailed: 'Não foi possível guardar. Tente novamente.',
    yourAccess: 'O seu acesso',
    ownWrite: 'O Poneva pode escrever em {name} por si. Permitiu isto em {date}.',
    ownWriteStop: 'Deixar de escrever por mim',
    ownWriteStopConfirm:
      'Impedir o Poneva de escrever em {name} por si? Só o proprietário ou um administrador pode voltar a ativar a escrita.',
    ownWriteStopYes: 'Parar a escrita',
    ownWriteKeep: 'Manter',
    ownRead:
      'O Poneva pode ler {name} por si. Enquanto estiver definido como Leitura, não altera nada lá.',
    audienceWrite: 'A escrita é permitida para todos os que podem usar {name}.',
    onlyRead: 'O Poneva só pode ler {name}.',
    youSuffix: '(você)',
    forEveryone: '{what}, para todos',
    activityTitle: 'Atividade',
    activityEmpty: 'Ainda não há atividade. Sempre que o Poneva usa uma ligação, aparece aqui.',
  },
  ro: {
    turnOn: 'Activează accesul',
    turnOnConfirm: 'Activați {name} cu accesul afișat mai sus?',
    failureUnknown: 'Motivul este necunoscut. Testați conexiunea pentru a verifica.',
    removeCredentialsConfirm:
      'Eliminați {name}? Poneva nu mai citește prin această conexiune și șterge datele de autentificare salvate. Pentru reconectare, le veți introduce din nou. Conversațiile și datele App rămân.',
    fieldRequired: 'Introduceți {field}.',
    fieldTooLong: '{field} este prea lung.',
    fieldInvalid: 'Verificați {field}.',
    testConnection: 'Testează conexiunea',
    allowWriteDone: 'Scriere permisă în {name}',
    agentWriteNeeded:
      '{name} este setat pe Citire. Ca acest agent să poată face modificări, setează-l pe Citire și scriere în Conexiuni.',
    agentWriteAsk:
      '{name} este setat pe Citire și doar proprietarul sau un administrator poate schimba asta. Roagă-i să îl seteze pe Citire și scriere ca acest agent să poată face modificări.',
    openConnections: 'Deschide Conexiuni',
    cardWriteNeeded:
      '{name} este setat pe Citire, așa că acțiunea nu poate rula până când nu este setat pe Citire și scriere în Conexiuni.',
    appWritesRow: 'Această aplicație face modificări în {name}',
    agentWritesRow: 'Acest agent face modificări în {name}',
    appWritesBody:
      'Rulările vor face modificări fără să întrebe. Poți dezactiva asta în Editează accesul.',
    appWritesAllow: 'Permite',
    cardEditAccess: 'Editează accesul',
    cardViewAccess: 'Vezi accesul',
    kindPipedream: 'Aplicație Pipedream',
    kindCustom: 'Conexiune personalizată',
    kindDatabase: 'Bază de date',
    connectedBy: 'conectată de {person}',
    whoOnlyYou: 'Doar tu',
    whoEveryone: 'Toată lumea din {company}',
    peopleNoun: 'one:persoană|few:persoane|other:de persoane',
    whatRead: 'Citire',
    whatReadWrite: 'Citire și scriere',
    statusConnected: 'Conectată',
    statusOff: 'Dezactivată',
    statusReconnect: 'Trebuie reconectată',
    statusUnavailable: 'Indisponibilă',
    sheetTitle: 'Acces la {name}',
    sheetTitleConnect: 'Cine poate folosi {name}?',
    appliesNext: 'Modificările se aplică la următoarea solicitare.',
    qWho: 'Cine o poate folosi',
    optOnlyMe: 'Doar eu',
    optOnlyMeBody: 'Doar tu o poți folosi. Nu apare niciodată altcuiva.',
    optEveryone: 'Toată lumea din {company}',
    optEveryoneBody: 'Oricine din {company} o poate folosi în chaturile și aplicațiile sale.',
    optPeople: 'Anumite persoane',
    addPeople: 'Adaugă persoane după nume sau e-mail…',
    ownerTag: 'Proprietar',
    peopleEmpty: 'Adaugă cel puțin o persoană sau alege Doar eu.',
    everyoneAdminOnly: 'Doar un proprietar sau un administrator poate partaja cu toată lumea.',
    qWhat: 'Ce poate face Poneva',
    optRead: 'Citire',
    optReadBody: 'Poneva poate căuta informații. Nu schimbă niciodată nimic.',
    optReadWrite: 'Citire și scriere',
    optReadWriteBody: 'Poneva poate face și modificări. Fiecare modificare este înregistrată.',
    reach: 'Ce poate accesa',
    actionsNoun: 'one:acțiune|few:acțiuni|other:de acțiuni',
    reachCount: '{actions} · {read} de citire · {write} de scriere',
    reachUnlabelled: 'Acțiunile pe care serviciul nu le etichetează contează ca modificări.',
    reachDatabase:
      'Poneva poate citi tot ce vede acest cont al bazei de date. Ca să partajezi mai puțin, conectează-te cu un cont care are acces doar la ce vrei să partajezi.',
    turnOff: 'Dezactivează accesul',
    turnOffConfirm:
      'Dezactivezi {name}? Nimeni nu o poate folosi până nu este reactivată. Nimic nu se șterge.',
    remove: 'Elimină conexiunea',
    removeConfirm:
      'Elimini {name}? Se șterge autentificarea salvată de Poneva. Chaturile și aplicațiile care o foloseau nu mai funcționează. Datele deja afișate sau salvate în aplicații rămân unde sunt.',
    readOnlyNote: 'Doar {owner} sau un administrator poate schimba asta.',
    saved: 'Acces actualizat. Se aplică la următoarea solicitare.',
    conflict: 'Altcineva a schimbat asta. Aceasta este setarea actuală.',
    saveFailed: 'Nu s-a putut salva. Încearcă din nou.',
    yourAccess: 'Accesul tău',
    ownWrite: 'Poneva poate scrie în {name} pentru tine. Ai permis asta pe {date}.',
    ownWriteStop: 'Oprește scrierea pentru mine',
    ownWriteStopConfirm:
      'Oprești scrierea Poneva în {name} pentru tine? Doar proprietarul sau un administrator poate reactiva scrierea.',
    ownWriteStopYes: 'Oprește scrierea',
    ownWriteKeep: 'Păstrează',
    ownRead:
      'Poneva poate citi {name} pentru tine. Cât timp este setat pe Citire, nu modifică nimic acolo.',
    audienceWrite: 'Scrierea este permisă pentru toți cei care pot folosi {name}.',
    onlyRead: 'Poneva poate doar să citească {name}.',
    youSuffix: '(tu)',
    forEveryone: '{what}, pentru toată lumea',
    activityTitle: 'Activitate',
    activityEmpty:
      'Încă nu există activitate. De fiecare dată când Poneva folosește o conexiune, apare aici.',
  },
  sk: {
    turnOn: 'Zapnúť prístup',
    turnOnConfirm: 'Zapnúť {name} s prístupom zobrazeným vyššie?',
    failureUnknown: 'Dôvod nie je známy. Overte ho testom pripojenia.',
    removeCredentialsConfirm:
      'Odstrániť {name}? Poneva prestane čítať cez toto pripojenie a odstráni uložené prihlasovacie údaje. Na opätovné pripojenie ich zadáte znova. Vaše chaty a údaje App zostanú.',
    fieldRequired: 'Zadajte {field}.',
    fieldTooLong: '{field} je príliš dlhé.',
    fieldInvalid: 'Skontrolujte {field}.',
    testConnection: 'Otestovať pripojenie',
    allowWriteDone: 'Zápis v službe {name} povolený',
    agentWriteNeeded:
      '{name} je nastavený na Čítanie. Aby v ňom tento agent mohol robiť zmeny, nastavte ho v Pripojeniach na Čítanie a zápis.',
    agentWriteAsk:
      '{name} je nastavený na Čítanie a zmeniť to môže len jeho vlastník alebo správca. Požiadajte ich, aby ho nastavili na Čítanie a zápis, aby v ňom tento agent mohol robiť zmeny.',
    openConnections: 'Otvoriť Pripojenia',
    cardWriteNeeded:
      '{name} je nastavený na Čítanie, takže to nemožno vykonať, kým nebude v Pripojeniach nastavený na Čítanie a zápis.',
    appWritesRow: 'Táto aplikácia robí zmeny v službe {name}',
    agentWritesRow: 'Tento agent robí zmeny v službe {name}',
    appWritesBody:
      'Spustenia budú robiť zmeny bez pýtania. Môžete to vypnúť v časti Upraviť prístup.',
    appWritesAllow: 'Povoliť',
    cardEditAccess: 'Upraviť prístup',
    cardViewAccess: 'Zobraziť prístup',
    kindPipedream: 'Aplikácia Pipedream',
    kindCustom: 'Vlastné pripojenie',
    kindDatabase: 'Databáza',
    connectedBy: 'pripojil(a) {person}',
    whoOnlyYou: 'Len vy',
    whoEveryone: 'Všetci vo firme {company}',
    peopleNoun: 'one:človek|few:ľudia|many:ľudí|other:ľudí',
    whatRead: 'Čítanie',
    whatReadWrite: 'Čítanie a zápis',
    statusConnected: 'Pripojené',
    statusOff: 'Vypnuté',
    statusReconnect: 'Treba znova pripojiť',
    statusUnavailable: 'Nedostupné',
    sheetTitle: 'Prístup k službe {name}',
    sheetTitleConnect: 'Kto môže používať službu {name}?',
    appliesNext: 'Zmeny sa uplatnia pri ďalšej požiadavke.',
    qWho: 'Kto ho môže používať',
    optOnlyMe: 'Len ja',
    optOnlyMeBody: 'Môžete ho používať len vy. Nikomu inému sa nezobrazí.',
    optEveryone: 'Všetci vo firme {company}',
    optEveryoneBody:
      'Ktokoľvek vo firme {company} ho môže používať vo svojich chatoch a aplikáciách.',
    optPeople: 'Konkrétni ľudia',
    addPeople: 'Pridajte ľudí podľa mena alebo e-mailu…',
    ownerTag: 'Vlastník',
    peopleEmpty: 'Pridajte aspoň jedného človeka alebo vyberte Len ja.',
    everyoneAdminOnly: 'So všetkými môže zdieľať iba vlastník alebo správca.',
    qWhat: 'Čo môže Poneva robiť',
    optRead: 'Čítanie',
    optReadBody: 'Poneva môže vyhľadávať informácie. Nikdy nič nemení.',
    optReadWrite: 'Čítanie a zápis',
    optReadWriteBody: 'Poneva môže aj robiť zmeny. Každá zmena sa zaznamená.',
    reach: 'Na čo dosiahne',
    actionsNoun: 'one:akcia|few:akcie|many:akcie|other:akcií',
    reachCount: '{actions} · čítanie: {read} · zápis: {write}',
    reachUnlabelled: 'Akcie, ktoré služba neoznačí, sa počítajú ako zmeny.',
    reachDatabase:
      'Poneva môže čítať všetko, čo vidí toto prihlásenie do databázy. Ak chcete zdieľať menej, pripojte sa prihlásením, ktoré má prístup len k tomu, čo chcete zdieľať.',
    turnOff: 'Vypnúť prístup',
    turnOffConfirm:
      'Vypnúť službu {name}? Nikto ju nebude môcť používať, kým ju znova nezapnete. Nič sa neodstráni.',
    remove: 'Odstrániť pripojenie',
    removeConfirm:
      'Odstrániť službu {name}? Odstráni sa prihlásenie, ktoré Poneva uložila. Chaty a aplikácie, ktoré ju používali, prestanú fungovať. Údaje, ktoré sa už zobrazili alebo uložili v aplikáciách, zostanú tam, kde sú.',
    readOnlyNote: 'Zmeniť to môže iba {owner} alebo správca.',
    saved: 'Prístup aktualizovaný. Platí od ďalšej požiadavky.',
    conflict: 'Niekto iný to zmenil. Toto je aktuálne nastavenie.',
    saveFailed: 'Uloženie zlyhalo. Skúste to znova.',
    yourAccess: 'Váš prístup',
    ownWrite: 'Poneva môže za vás zapisovať do služby {name}. Povolili ste to {date}.',
    ownWriteStop: 'Zastaviť zápis za mňa',
    ownWriteStopConfirm:
      'Zastaviť zápis Poneva do služby {name} za vás? Zápis znova zapnúť môže iba vlastník alebo správca.',
    ownWriteStopYes: 'Zastaviť zápis',
    ownWriteKeep: 'Ponechať',
    ownRead:
      'Poneva môže za vás čítať službu {name}. Kým je nastavená na Čítanie, nič v nej nemení.',
    audienceWrite: 'Zápis je povolený pre každého, kto môže používať službu {name}.',
    onlyRead: 'Poneva môže službu {name} iba čítať.',
    youSuffix: '(vy)',
    forEveryone: '{what}, pre všetkých',
    activityTitle: 'Aktivita',
    activityEmpty:
      'Zatiaľ žiadna aktivita. Zakaždým, keď Poneva použije pripojenie, zobrazí sa tu.',
  },
  sl: {
    turnOn: 'Vklopi dostop',
    turnOnConfirm: 'Vklopim {name} z zgoraj prikazanim dostopom?',
    failureUnknown: 'Razlog ni znan. Preverite ga s preizkusom povezave.',
    removeCredentialsConfirm:
      'Odstranim {name}? Poneva preneha brati prek te povezave in izbriše shranjene podatke za prijavo. Za ponovno povezavo jih boste vnesli znova. Vaši klepeti in podatki App ostanejo.',
    fieldRequired: 'Vnesite {field}.',
    fieldTooLong: '{field} je predolgo.',
    fieldInvalid: 'Preverite {field}.',
    testConnection: 'Preizkusi povezavo',
    allowWriteDone: 'Pisanje v storitev {name} je dovoljeno',
    agentWriteNeeded:
      '{name} je nastavljen na Branje. Da bo ta agent lahko vnašal spremembe, ga v Povezavah nastavite na Branje in pisanje.',
    agentWriteAsk:
      '{name} je nastavljen na Branje in to lahko spremeni le lastnik ali skrbnik. Prosite jih, naj ga nastavijo na Branje in pisanje, da bo ta agent lahko vnašal spremembe.',
    openConnections: 'Odpri Povezave',
    cardWriteNeeded:
      '{name} je nastavljen na Branje, zato tega ni mogoče izvesti, dokler v Povezavah ni nastavljen na Branje in pisanje.',
    appWritesRow: 'Ta aplikacija spreminja podatke v storitvi {name}',
    agentWritesRow: 'Ta agent spreminja podatke v storitvi {name}',
    appWritesBody:
      'Zagoni bodo izvajali spremembe brez vprašanja. To lahko izklopite v razdelku Uredi dostop.',
    appWritesAllow: 'Dovoli',
    cardEditAccess: 'Uredi dostop',
    cardViewAccess: 'Prikaži dostop',
    kindPipedream: 'Aplikacija Pipedream',
    kindCustom: 'Povezava po meri',
    kindDatabase: 'Zbirka podatkov',
    connectedBy: 'povezal(a): {person}',
    whoOnlyYou: 'Samo vi',
    whoEveryone: 'Vsi v podjetju {company}',
    peopleNoun: 'one:oseba|two:osebi|few:osebe|other:oseb',
    whatRead: 'Branje',
    whatReadWrite: 'Branje in pisanje',
    statusConnected: 'Povezano',
    statusOff: 'Izklopljeno',
    statusReconnect: 'Potrebna je ponovna povezava',
    statusUnavailable: 'Ni na voljo',
    sheetTitle: 'Dostop do storitve {name}',
    sheetTitleConnect: 'Kdo lahko uporablja storitev {name}?',
    appliesNext: 'Spremembe veljajo za naslednjo zahtevo.',
    qWho: 'Kdo jo lahko uporablja',
    optOnlyMe: 'Samo jaz',
    optOnlyMeBody: 'Uporabljate jo lahko samo vi. Nikomur drugemu se nikoli ne prikaže.',
    optEveryone: 'Vsi v podjetju {company}',
    optEveryoneBody:
      'Vsak v podjetju {company} jo lahko uporablja v svojih klepetih in aplikacijah.',
    optPeople: 'Določene osebe',
    addPeople: 'Dodajte osebe po imenu ali e-poštnem naslovu …',
    ownerTag: 'Lastnik',
    peopleEmpty: 'Dodajte vsaj eno osebo ali izberite Samo jaz.',
    everyoneAdminOnly: 'Z vsemi lahko deli samo lastnik ali skrbnik.',
    qWhat: 'Kaj lahko Poneva počne',
    optRead: 'Branje',
    optReadBody: 'Poneva lahko poišče informacije. Nikoli ničesar ne spremeni.',
    optReadWrite: 'Branje in pisanje',
    optReadWriteBody: 'Poneva lahko tudi kaj spremeni. Vsaka sprememba se zabeleži.',
    reach: 'Kaj lahko doseže',
    actionsNoun: 'one:dejanje|two:dejanji|few:dejanja|other:dejanj',
    reachCount: '{actions} · branje: {read} · pisanje: {write}',
    reachUnlabelled: 'Dejanja, ki jih storitev ne označi, štejejo kot spremembe.',
    reachDatabase:
      'Poneva lahko bere vse, kar vidi ta prijava v zbirko podatkov. Če želite deliti manj, se povežite s prijavo, ki ima dostop samo do tega, kar želite deliti.',
    turnOff: 'Izklopi dostop',
    turnOffConfirm:
      'Želite izklopiti storitev {name}? Nihče je ne bo mogel uporabljati, dokler je znova ne vklopite. Nič se ne izbriše.',
    remove: 'Odstrani povezavo',
    removeConfirm:
      'Želite odstraniti storitev {name}? S tem se izbriše shranjena prijava. Klepeti in aplikacije, ki so jo uporabljali, ne bodo več delovali. Podatki, ki so že prikazani ali shranjeni v aplikacijah, ostanejo, kjer so.',
    readOnlyNote: 'To lahko spremeni samo {owner} ali skrbnik.',
    saved: 'Dostop posodobljen. Velja za naslednjo zahtevo.',
    conflict: 'Nekdo drug je to spremenil. To je trenutna nastavitev.',
    saveFailed: 'Shranjevanje ni uspelo. Poskusite znova.',
    yourAccess: 'Vaš dostop',
    ownWrite: 'Poneva lahko namesto vas piše v storitev {name}. To ste dovolili dne {date}.',
    ownWriteStop: 'Ustavi pisanje zame',
    ownWriteStopConfirm:
      'Želite, da Poneva ne piše več v storitev {name} namesto vas? Pisanje lahko znova vklopi samo lastnik ali skrbnik.',
    ownWriteStopYes: 'Ustavi pisanje',
    ownWriteKeep: 'Obdrži',
    ownRead:
      'Poneva lahko namesto vas bere storitev {name}. Dokler je nastavljena na Branje, v njej ničesar ne spreminja.',
    audienceWrite: 'Pisanje je dovoljeno vsem, ki lahko uporabljajo storitev {name}.',
    onlyRead: 'Poneva lahko storitev {name} samo bere.',
    youSuffix: '(vi)',
    forEveryone: '{what}, za vse',
    activityTitle: 'Dejavnost',
    activityEmpty: 'Dejavnosti še ni. Vsakič, ko Poneva uporabi povezavo, se prikaže tukaj.',
  },
  sv: {
    turnOn: 'Slå på åtkomst',
    turnOnConfirm: 'Slå på {name} med åtkomsten som visas ovan?',
    failureUnknown: 'Orsaken är okänd. Testa anslutningen för att kontrollera.',
    removeCredentialsConfirm:
      'Ta bort {name}? Poneva slutar läsa via anslutningen och raderar de sparade inloggningsuppgifterna. För att ansluta igen anger du dem på nytt. Dina chattar och appdata finns kvar.',
    fieldRequired: 'Ange {field}.',
    fieldTooLong: '{field} är för långt.',
    fieldInvalid: 'Kontrollera {field}.',
    testConnection: 'Testa anslutning',
    allowWriteDone: 'Skrivning tillåten i {name}',
    agentWriteNeeded:
      '{name} är inställd på Läsning. Ställ in den på Läsning och skrivning i Anslutningar så att den här agenten kan göra ändringar.',
    agentWriteAsk:
      '{name} är inställd på Läsning, och bara ägaren eller en administratör kan ändra det. Be dem ställa in den på Läsning och skrivning så att den här agenten kan göra ändringar.',
    openConnections: 'Öppna Anslutningar',
    cardWriteNeeded:
      '{name} är inställd på Läsning, så det här kan inte köras förrän den är inställd på Läsning och skrivning i Anslutningar.',
    appWritesRow: 'Den här appen gör ändringar i {name}',
    agentWritesRow: 'Den här agenten gör ändringar i {name}',
    appWritesBody:
      'Körningar gör ändringar utan att fråga. Du kan stänga av det under Redigera åtkomst.',
    appWritesAllow: 'Tillåt',
    cardEditAccess: 'Redigera åtkomst',
    cardViewAccess: 'Visa åtkomst',
    kindPipedream: 'Pipedream-app',
    kindCustom: 'Egen anslutning',
    kindDatabase: 'Databas',
    connectedBy: 'ansluten av {person}',
    whoOnlyYou: 'Bara du',
    whoEveryone: 'Alla på {company}',
    peopleNoun: 'one:person|other:personer',
    whatRead: 'Läsning',
    whatReadWrite: 'Läsning och skrivning',
    statusConnected: 'Ansluten',
    statusOff: 'Avstängd',
    statusReconnect: 'Behöver anslutas igen',
    statusUnavailable: 'Inte tillgänglig',
    sheetTitle: 'Åtkomst till {name}',
    sheetTitleConnect: 'Vem kan använda {name}?',
    appliesNext: 'Ändringar gäller från nästa förfrågan.',
    qWho: 'Vem kan använda den',
    optOnlyMe: 'Bara jag',
    optOnlyMeBody: 'Bara du kan använda den. Den visas aldrig för någon annan.',
    optEveryone: 'Alla på {company}',
    optEveryoneBody: 'Alla på {company} kan använda den i sina chattar och appar.',
    optPeople: 'Utvalda personer',
    addPeople: 'Lägg till personer med namn eller e-post…',
    ownerTag: 'Ägare',
    peopleEmpty: 'Lägg till minst en person, eller välj Bara jag.',
    everyoneAdminOnly: 'Bara en ägare eller administratör kan dela med alla.',
    qWhat: 'Vad Poneva kan göra',
    optRead: 'Läsning',
    optReadBody: 'Poneva kan slå upp saker. Den ändrar aldrig något.',
    optReadWrite: 'Läsning och skrivning',
    optReadWriteBody: 'Poneva kan också göra ändringar. Varje ändring registreras.',
    reach: 'Vad den kan nå',
    actionsNoun: 'one:åtgärd|other:åtgärder',
    reachCount: '{actions} · {read} läsning · {write} skrivning',
    reachUnlabelled: 'Åtgärder som tjänsten inte märker räknas som ändringar.',
    reachDatabase:
      'Poneva kan läsa allt som den här databasinloggningen kan se. Vill du dela mindre ansluter du med en inloggning som bara har åtkomst till det du vill dela.',
    turnOff: 'Stäng av åtkomst',
    turnOffConfirm:
      'Stänga av {name}? Ingen kan använda den förrän den slås på igen. Inget raderas.',
    remove: 'Ta bort anslutning',
    removeConfirm:
      'Ta bort {name}? Det raderar inloggningen som Poneva sparade. Chattar och appar som använde den slutar fungera. Data som redan visats eller sparats i appar ligger kvar där den är.',
    readOnlyNote: 'Bara {owner} eller en administratör kan ändra det här.',
    saved: 'Åtkomsten är uppdaterad. Gäller från nästa förfrågan.',
    conflict: 'Någon annan har ändrat det här. Här är den aktuella inställningen.',
    saveFailed: 'Det gick inte att spara. Försök igen.',
    yourAccess: 'Din åtkomst',
    ownWrite: 'Poneva kan skriva till {name} åt dig. Du tillät det {date}.',
    ownWriteStop: 'Sluta skriva åt mig',
    ownWriteStopConfirm:
      'Ska Poneva sluta skriva till {name} åt dig? Bara ägaren eller en administratör kan slå på skrivning igen.',
    ownWriteStopYes: 'Sluta skriva',
    ownWriteKeep: 'Behåll',
    ownRead:
      'Poneva kan läsa {name} åt dig. Den ändrar inget där så länge den är inställd på Läsning.',
    audienceWrite: 'Skrivning är tillåten för alla som kan använda {name}.',
    onlyRead: 'Poneva kan bara läsa {name}.',
    youSuffix: '(du)',
    forEveryone: '{what}, för alla',
    activityTitle: 'Aktivitet',
    activityEmpty: 'Ingen aktivitet än. Varje gång Poneva använder en anslutning visas det här.',
  },
} as const;
export type ConnectionAccessCopyKey = keyof typeof copy.en;
export default copy satisfies NamespaceCatalog<ConnectionAccessCopyKey>;
